var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import axiosRetry from "axios-retry";
import createTestConfig from "./core/createTestConfig";
import { TestNames } from "./config";
import Utils, { logResults } from "./utils";
import { Estimates } from "./estimates";
import { overrideGetstatsFunctions, undoOveerideRTCPeerConnection } from "./get-rtc-stats";
var version = "2.0.6";
var timeInBackground = 0; // initialize total time in background at beginning of each test
var testTimeInBackground = 0; // initialize test total time in background at beginning of each test
var inactiveAt; // timestamp when browser become inactive.
var testInactiveAt; // test timestamp when browser become inactive.
var wakeLock = null; /// For Screen Wake Lock API
axios.defaults.timeout = 30000;
axiosRetry(axios, {
    retries: 2,
    shouldResetTimeout: true,
    retryCondition: function () { return true; },
    retryDelay: function (retryCount) {
        console.warn("axiosRetry retryCount:" + retryCount + " " + Math.round(Date.now() / 1000));
        return retryCount * 2000;
    },
});
var cancelControler = function (callback) {
    var reject;
    var called = false;
    var error = { error: "Tests run was canceled" };
    var execute = function () {
        callback();
        if (typeof reject === "function")
            reject(error);
    };
    return {
        handler: function () {
            if (called)
                return;
            called = true;
            return execute();
        },
        checkCalled: function () {
            if (called)
                throw error;
        },
        isCalled: function () { return called; },
        promise: function () {
            return new Promise(function (_, rej) {
                if (called) {
                    return rej(error);
                }
                reject = rej;
            });
        },
    };
};
// Tests list that will show message in log if remains more then 5 sec in background https://redmine.testrtc.com/issues/10131#note-3
var foregroundTestList = [
    "BandwidthSpeed",
    "Throughput",
    "CallQuality",
    "VideoQuality",
    "VideoP2P",
    "VideoBandwidth",
];
var TestStatus = {
    red: "red",
    yellow: "yellow",
    green: "green",
};
var lazyLoadModule = function (awaitableImport, retries, moduleFunction) {
    if (retries === void 0) { retries = 3; }
    if (moduleFunction === void 0) { moduleFunction = "default"; }
    return __awaiter(void 0, void 0, void 0, function () {
        var module_1, err_1, newRetries;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 6]);
                    return [4 /*yield*/, awaitableImport()];
                case 1:
                    module_1 = _a.sent();
                    return [2 /*return*/, module_1[moduleFunction]];
                case 2:
                    err_1 = _a.sent();
                    console.error("tests:lazyLoadModule " + err_1.message, {
                        err: err_1.stack,
                    });
                    if (!(retries > 0)) return [3 /*break*/, 4];
                    newRetries = retries - 1;
                    console.log("Lazy load module failed. Retries left: " + newRetries);
                    return [4 /*yield*/, lazyLoadModule(awaitableImport, newRetries)];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    console.log("Lazy load module failed due to " + err_1.message);
                    throw new Error("Unable to load the required module properly due to a network issue. Please try again later, and if the issue persists, please contact our support team for further assistance.");
                case 5: return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
};
var getUrl = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios.get(url)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
function parseRegions(testRunInfo, serverTests) {
    return serverTests.map(function (element) {
        var temp = __assign({}, element);
        // aws routed url does not have region prefix
        var region = testRunInfo.testConfig.datacenterRegions.find(function (item) {
            if (Array.isArray(item.url)) {
                return item.url.indexOf(element.url) > -1;
            }
            else {
                return item.url === element.url;
            }
        });
        if (region) {
            temp.region = region.title;
        }
        delete temp.url;
        return temp;
    });
}
function GetConnectionInfoName(testRunInfo, testNameEnum) {
    var _a;
    var testName = TestNames[testNameEnum].toString();
    var testConfig = testRunInfo.testConfig[testName];
    // In case of probe , which has both call quality and video quality test
    if (testName === "VideoQuality" &&
        ((_a = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testConfig) === null || _a === void 0 ? void 0 : _a.ConnectionName) &&
        typeof testRunInfo.testConfig.ConnectionName === "object") {
        var connectionNameKey = Object.keys(testRunInfo.testConfig.ConnectionName);
        if (connectionNameKey && connectionNameKey.length > 0) {
            return testRunInfo.testConfig.ConnectionName[connectionNameKey[0]];
        }
    }
    return (testConfig === null || testConfig === void 0 ? void 0 : testConfig.ConnectionInfoName) || testRunInfo.testConfig.ConnectionInfoName;
}
function GetTestParameter(testRunInfo, testName, paramName) {
    var testConfig = testRunInfo.testConfig[testName];
    return testConfig ? testConfig[paramName] : undefined;
}
/**
 * @deprecated Will be deleted in next version. Use GetTestCredentials2 instead.
 */
// async function GetTestCredentials(testRunInfo: ITestRunInfo) {
//   if (!testRunInfo.publicTurn) {
//     try {
//       const data = {
//         accountSid: testRunInfo.testConfig.AccountSid,
//         authToken: testRunInfo.testConfig.AuthToken,
//         applicationSid: testRunInfo.testConfig.ApplicationSid,
//       };
//       const response = await axios.post(testRunInfo.testConfig.CredentialsApiUrl, data);
//       const result = response.data;
//
//       testRunInfo.publicTurn = [
//         {
//           username: result.username,
//           credential: result.credential,
//           urls: testRunInfo.testConfig.turnServers,
//         },
//       ];
//     } catch (err:any) {
//       throw new Error(`Failed to get test credentials (${err.message})`);
//     }
//   }
//
//   return testRunInfo.publicTurn;
// }
function getTokboxIceServers(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var connectionInfo, getTurnServers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                        connectionName: "tokbox",
                    })];
                case 1:
                    connectionInfo = _a.sent();
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./tokbox/tokbox-get-turn-servers"); })];
                case 2:
                    getTurnServers = _a.sent();
                    return [2 /*return*/, getTurnServers(connectionInfo)];
            }
        });
    });
}
function getZaurusServers(testCredentials) {
    return [testCredentials.servers.turntcp, testCredentials.servers.turnudp];
}
function getSubspaceIceServers(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var connectionInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                        connectionName: "subspace",
                    })];
                case 1:
                    connectionInfo = _a.sent();
                    return [2 /*return*/, connectionInfo.servers.ice_servers];
            }
        });
    });
}
function getGliaTurnServers(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var connectionInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                        connectionName: "glia",
                    })];
                case 1:
                    connectionInfo = _a.sent();
                    return [2 /*return*/, connectionInfo.servers];
            }
        });
    });
}
function getLogitechTurnServers(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var regionTitle, _a, regionCode, code, connectionInfo;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!testRunInfo.testConfig.region) return [3 /*break*/, 1];
                    _a = { code: testRunInfo.testConfig.region };
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, GetAwsOptimalServer(testRunInfo)];
                case 2:
                    _a = _b.sent();
                    _b.label = 3;
                case 3:
                    regionTitle = _a;
                    regionCode = "";
                    code = testRunInfo.testConfig.datacenterRegions.find(function (item) { return item.code === regionTitle.code; });
                    if (code) {
                        regionCode = code.code;
                    }
                    return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                            connectionName: "logitech",
                            regionCode: regionCode,
                        })];
                case 4:
                    connectionInfo = _b.sent();
                    return [2 /*return*/, connectionInfo.turnCredentials];
            }
        });
    });
}
function getItracksIceServers(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var connectionInfo, getTurnServers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                        connectionName: "itracks",
                    })];
                case 1:
                    connectionInfo = _a.sent();
                    return [4 /*yield*/, lazyLoadModule(function () {
                            return import("./frozenmountain/frozenmountain-get-turn-servers");
                        })];
                case 2:
                    getTurnServers = _a.sent();
                    return [2 /*return*/, getTurnServers(testRunInfo, connectionInfo)];
            }
        });
    });
}
function getGenesysTurnServers(testRunInfo) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var result, mediaRegion, genesysTwilioTurnAssociation, twilioTurnRegion_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                        connectionName: "twilio-testrtc-account",
                    })];
                case 1:
                    result = _d.sent();
                    mediaRegion = (_b = (_a = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testConfig) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.mediaRegion;
                    genesysTwilioTurnAssociation = (_c = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testConfig) === null || _c === void 0 ? void 0 : _c.twilioTurnSvrAssociationMap;
                    if (mediaRegion && genesysTwilioTurnAssociation) {
                        twilioTurnRegion_1 = genesysTwilioTurnAssociation[mediaRegion];
                        result.turnServers = result.turnServers
                            .map(function (url) {
                            if (url) {
                                if (twilioTurnRegion_1)
                                    return url.replace("global", twilioTurnRegion_1);
                                else
                                    return url;
                            }
                        })
                            .filter(function (url) {
                            if (/turn:/.test(url) || /turns:/.test(url)) {
                                var strTransport = Utils.extractUrlValue("transport", url);
                                return strTransport === "udp";
                            }
                            return false;
                        });
                    }
                    testRunInfo.publicTurn = [
                        {
                            username: result.username,
                            credential: result.credential,
                            urls: result.turnServers,
                        },
                    ];
                    return [2 /*return*/, testRunInfo.publicTurn || []];
            }
        });
    });
}
function GetTestCredentials2(testNameEnum, testRunInfo) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var testName, connectionName, intermidiateRTCIceServers, testConfig, useConnectionOverrideConfig, testCredentials, localCredentials, result, _d, err_2, optimalServer_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    testName = TestNames[testNameEnum].toString();
                    connectionName = GetConnectionInfoName(testRunInfo, testNameEnum);
                    intermidiateRTCIceServers = testRunInfo.intermidiatesResults["RTCIceServers"];
                    if (connectionName === "liveswitch" && !intermidiateRTCIceServers) {
                        connectionName = "twilio-testrtc-account";
                    }
                    testConfig = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testConfig[testName];
                    useConnectionOverrideConfig = testConfig === null || testConfig === void 0 ? void 0 : testConfig.connectionOverrideIceServers;
                    if (useConnectionOverrideConfig) {
                        if (testRunInfo.intermidiatesResults["RTCIceServers"]) {
                            testCredentials = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.intermidiatesResults["RTCIceServers"];
                            testRunInfo.logMessage("Use discovered RTCIceServers");
                            testRunInfo.logMessage(testCredentials);
                            return [2 /*return*/, Promise.resolve(testCredentials)];
                        }
                        else {
                            throw new Error("connectionOverrideIceServers=true, Missing connection RTCIceServers");
                        }
                    }
                    localCredentials = ((_a = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testConfig) === null || _a === void 0 ? void 0 : _a.TestCredentials) &&
                        ((_b = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testConfig) === null || _b === void 0 ? void 0 : _b.TestCredentials[connectionName]);
                    if (!localCredentials) return [3 /*break*/, 1];
                    console.log("tests:GetTestCredentials2 use localCredentials from " + connectionName, {
                        localCredentials: localCredentials,
                    });
                    return [2 /*return*/, Promise.resolve(localCredentials)];
                case 1:
                    if (!(connectionName === "itracks")) return [3 /*break*/, 2];
                    return [2 /*return*/, getItracksIceServers(testRunInfo)];
                case 2:
                    if (!(connectionName === "subspace")) return [3 /*break*/, 3];
                    return [2 /*return*/, getSubspaceIceServers(testRunInfo)];
                case 3:
                    if (!(connectionName === "glia")) return [3 /*break*/, 4];
                    return [2 /*return*/, getGliaTurnServers(testRunInfo)];
                case 4:
                    if (!(connectionName === "logitech")) return [3 /*break*/, 5];
                    return [2 /*return*/, getLogitechTurnServers(testRunInfo)];
                case 5:
                    if (!(connectionName === "genesys")) return [3 /*break*/, 6];
                    return [2 /*return*/, getGenesysTurnServers(testRunInfo)];
                case 6:
                    if (!!testRunInfo.publicTurn) return [3 /*break*/, 18];
                    _e.label = 7;
                case 7:
                    _e.trys.push([7, 17, , 18]);
                    result = void 0;
                    if (!testRunInfo.testConfig.connectionInfo) return [3 /*break*/, 8];
                    result = testRunInfo.testConfig.connectionInfo;
                    return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                        connectionName: connectionName,
                    })];
                case 9:
                    result = _e.sent();
                    _e.label = 10;
                case 10:
                    if (!(connectionName === "zaurus")) return [3 /*break*/, 11];
                    testRunInfo.publicTurn = getZaurusServers(result);
                    return [3 /*break*/, 16];
                case 11:
                    if (!(connectionName === "liveswitch" && intermidiateRTCIceServers)) return [3 /*break*/, 12];
                    testRunInfo.publicTurn = intermidiateRTCIceServers;
                    return [3 /*break*/, 16];
                case 12:
                    if (!result.testCredentials) return [3 /*break*/, 13];
                    testRunInfo.publicTurn = result.testCredentials;
                    return [3 /*break*/, 16];
                case 13:
                    if (!(result.provider === "opentok")) return [3 /*break*/, 15];
                    _d = testRunInfo;
                    return [4 /*yield*/, getTokboxIceServers(testRunInfo)];
                case 14:
                    _d.publicTurn = _e.sent();
                    return [3 /*break*/, 16];
                case 15:
                    if (connectionName === "subspace") {
                        testRunInfo.publicTurn = result.servers.ice_servers;
                    }
                    else {
                        testRunInfo.publicTurn = [
                            {
                                username: result.username,
                                credential: result.credential,
                                urls: result.turnServers,
                            },
                        ];
                    }
                    _e.label = 16;
                case 16: return [3 /*break*/, 18];
                case 17:
                    err_2 = _e.sent();
                    if ((err_2 === null || err_2 === void 0 ? void 0 : err_2.code) === 4010 && (err_2 === null || err_2 === void 0 ? void 0 : err_2.name) === "OT_SOCKET_CLOSE_TIMEOUT") {
                        throw new Error(" There was an error while establishing a connection using the OpenTok library. Please retry, and if the error persists, kindly contact our support team for assistance.");
                    }
                    else {
                        console.log("Error GetTestCredentials2", { err: err_2 === null || err_2 === void 0 ? void 0 : err_2.stack });
                        if (err_2 === null || err_2 === void 0 ? void 0 : err_2.message.includes("Network Error")) {
                            // Customized error message for the specific error //https://redmine.testrtc.com/issues/8676#note-2
                            throw new Error("There was an network error while retrieving the connection information . Please retry, and if the error persists, kindly contact our support team for assistance");
                        }
                        else {
                            // Generic error message for other errors
                            throw new Error("Failed to get test credentials (" + err_2.message + ")");
                        }
                    }
                    return [3 /*break*/, 18];
                case 18:
                    if (!testRunInfo.testConfig.turnServerFilterByRegion) return [3 /*break*/, 20];
                    return [4 /*yield*/, GetAwsOptimalServer(testRunInfo)];
                case 19:
                    optimalServer_1 = _e.sent();
                    testRunInfo.publicTurn = (_c = testRunInfo.publicTurn) === null || _c === void 0 ? void 0 : _c.map(function (iceServer) { return (__assign(__assign({}, iceServer), { urls: Array.isArray(iceServer.urls)
                            ? iceServer.urls.filter(function (url) { return url.includes(optimalServer_1.code); })
                            : iceServer.urls })); });
                    // console.log(`GetTestCredentials2 turnServerFilterByRegion=true filter by region`, {
                    //   optimalServer,
                    //   publicTurn: testRunInfo.publicTurn,
                    // });
                    testRunInfo.logMessage("Use region: " + optimalServer_1.title + " TURN servers");
                    _e.label = 20;
                case 20: return [2 /*return*/, testRunInfo.publicTurn || []];
            }
        });
    });
}
var IsLocalhost = function () {
    return (window.location.hostname === "localhost" ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
};
function GetConnectionInfo(testRunInfo, options) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function () {
        var error, localConnectionInfo, netlifyBaseUrl, netlifyUrl, url, data, response, err_3, code, orgMsg, msg;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (options.connectionName === "livevox_custom" || options.connectionName === "dialpad_custom") {
                        return [2 /*return*/, (_a = testRunInfo.testConfig.CallQuality) === null || _a === void 0 ? void 0 : _a.additonalConfig];
                    }
                    localConnectionInfo = options.connectionName &&
                        testRunInfo.testConfig.TestCredentials &&
                        testRunInfo.testConfig.TestCredentials[options.connectionName];
                    if (localConnectionInfo) {
                        return [2 /*return*/, localConnectionInfo];
                    }
                    netlifyBaseUrl = (_b = testRunInfo.testConfig.options.netlifyBaseUrl) !== null && _b !== void 0 ? _b : (IsLocalhost() ? "http://localhost:9000" : "");
                    netlifyUrl = netlifyBaseUrl + "/.netlify/functions/get-customer-config";
                    url = netlifyUrl;
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    data = {
                        connectionName: options.connectionName,
                        mediaMode: options.mediaMode,
                        region: options.regionCode || testRunInfo.testConfig.region || undefined,
                    };
                    return [4 /*yield*/, axios.post(url, IsLocalhost() ? JSON.stringify(data) : data)];
                case 2:
                    response = _f.sent();
                    return [2 /*return*/, response.data];
                case 3:
                    err_3 = _f.sent();
                    code = ((_c = err_3.response) === null || _c === void 0 ? void 0 : _c.code) || "";
                    orgMsg = ((_d = err_3.response) === null || _d === void 0 ? void 0 : _d.data) || ((_e = err_3.response) === null || _e === void 0 ? void 0 : _e.body);
                    error = orgMsg || err_3.message;
                    msg = "Failed to get connection info ( Error Code: " + code + " " + err_3.message + " " + orgMsg;
                    testRunInfo.logMessage(msg, "red");
                    testRunInfo.logMessage({
                        url: url,
                        connectionName: options.connectionName,
                        mediaMode: options.mediaMode,
                    }, "red");
                    console.warn("Failed to GetConnectionInfo  from " + url + ", " + err_3.message + " " + orgMsg, {
                        url: url,
                        orgMsg: orgMsg,
                        errFull: err_3,
                        errResp: JSON.stringify((err_3 === null || err_3 === void 0 ? void 0 : err_3.response) || ""),
                        err: err_3.stack,
                        errorType: typeof err_3,
                        errToJson: (err_3 === null || err_3 === void 0 ? void 0 : err_3.toJSON) ? err_3 === null || err_3 === void 0 ? void 0 : err_3.toJSON() : "no toJSON",
                        connectionName: options.connectionName,
                        mediaMode: options.mediaMode,
                    });
                    return [3 /*break*/, 4];
                case 4: 
                // if (
                //   !testRunInfo.testConfig.netlifyUrl &&
                //   testRunInfo.testConfig.datacenterRegions &&
                //   testRunInfo.testConfig.datacenterRegions.length > 0
                // ) {
                //   const datacenterRegions = testRunInfo.testConfig.datacenterRegions;
                //   for (let i = 0; i < datacenterRegions.length && i < 2; i++) {
                //     if (Array.isArray(datacenterRegions[i].url)) {
                //       for (let j = 0; j < datacenterRegions[i].url.length; j++) {
                //         const strUrl = datacenterRegions[i].url[j] + "/access/connectionInfo";
                //         arrURLs.push(strUrl);
                //       }
                //     } else {
                //       const strUrl = datacenterRegions[i].url + "/access/connectionInfo";
                //       arrURLs.push(strUrl);
                //     }
                //   }
                // }
                throw new Error(((error === null || error === void 0 ? void 0 : error.errMessage) ||
                    (error === null || error === void 0 ? void 0 : error.message) ||
                    error ||
                    "Failed connecting to server") + ", rtc-100:GetConnectionInfo");
            }
        });
    });
}
export function GetConnectionInfoForGenesysLogin(options) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var error, netlifyBaseUrl, netlifyUrl, url, data, response, err_4, code, orgMsg;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    netlifyBaseUrl = IsLocalhost() ? "http://localhost:9000" : "";
                    netlifyUrl = netlifyBaseUrl + "/.netlify/functions/get-customer-config";
                    url = netlifyUrl;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    data = {
                        connectionName: "genesys",
                        options: options,
                    };
                    return [4 /*yield*/, axios.post(url, IsLocalhost() ? JSON.stringify(data) : data)];
                case 2:
                    response = _d.sent();
                    return [2 /*return*/, response];
                case 3:
                    err_4 = _d.sent();
                    code = ((_a = err_4.response) === null || _a === void 0 ? void 0 : _a.code) || "";
                    orgMsg = ((_b = err_4.response) === null || _b === void 0 ? void 0 : _b.data) || ((_c = err_4.response) === null || _c === void 0 ? void 0 : _c.body);
                    error = orgMsg || err_4.message;
                    console.warn("Failed to GetConnectionInfo  from " + url + ", " + err_4.message + " " + orgMsg, {
                        url: url,
                        orgMsg: orgMsg,
                        errFull: err_4,
                        errResp: JSON.stringify((err_4 === null || err_4 === void 0 ? void 0 : err_4.response) || ""),
                        err: err_4.stack,
                        errorType: typeof err_4,
                        errToJson: (err_4 === null || err_4 === void 0 ? void 0 : err_4.toJSON) ? err_4 === null || err_4 === void 0 ? void 0 : err_4.toJSON() : "no toJSON",
                    });
                    return [3 /*break*/, 4];
                case 4: throw new Error(((error === null || error === void 0 ? void 0 : error.errMessage) ||
                    (error === null || error === void 0 ? void 0 : error.message) ||
                    error ||
                    "Failed connecting to server") + ", GetConnectionInfoForGenesysLogin");
            }
        });
    });
}
function GetCapabilityToken(testRunInfo, testNameEnum) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var connectionName, data, arrURLs, netlifyBaseUrl, netlifyUrl, i, url, response, err_5, msg;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!testRunInfo.capabilityToken) return [3 /*break*/, 6];
                    connectionName = GetConnectionInfoName(testRunInfo, testNameEnum);
                    data = {
                        connectionName: connectionName,
                    };
                    arrURLs = [];
                    netlifyBaseUrl = (_a = testRunInfo.testConfig.options.netlifyBaseUrl) !== null && _a !== void 0 ? _a : (IsLocalhost() ? "http://localhost:9000" : "");
                    netlifyUrl = netlifyBaseUrl + "/.netlify/functions/get-capability-token";
                    arrURLs.push(netlifyUrl);
                    i = 0;
                    _b.label = 1;
                case 1:
                    if (!(i < arrURLs.length)) return [3 /*break*/, 6];
                    url = arrURLs[i];
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, axios.post(url, IsLocalhost() ? JSON.stringify(data) : data)];
                case 3:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
                case 4:
                    err_5 = _b.sent();
                    msg = "Failed to get capability token with url: " + url + " , Error: " + err_5.message + ", ERROR STACK: " + JSON.stringify((err_5 === null || err_5 === void 0 ? void 0 : err_5.response) || "");
                    testRunInfo.logMessage(msg, "red");
                    return [3 /*break*/, 5];
                case 5:
                    i++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/];
            }
        });
    });
}
function GetAwsOptimalServer(testRunInfo, forceOptimalServerByPingAll) {
    var _a;
    if (forceOptimalServerByPingAll === void 0) { forceOptimalServerByPingAll = false; }
    return __awaiter(this, void 0, void 0, function () {
        var verbose, findByRegionCode, optimalRegionName_1, optimalRegion, pingResults, config, url, regionCode_1, _b, optimalRegion;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    verbose = testRunInfo.testConfig.verbose;
                    findByRegionCode = function (regionCode) {
                        var optimalRegion = testRunInfo.testConfig.datacenterRegions.find(function (x) {
                            return x.code === regionCode.toLowerCase() || x.twilioRegion === regionCode.toLowerCase();
                        });
                        console.log("LOG 1");
                        if (!optimalRegion) {
                            throw new Error("URL requested region " + testRunInfo.testConfig.options.region + " unknown, valid regions are " + testRunInfo.testConfig.datacenterRegions
                                .filter(function (_a) {
                                var twilioRegion = _a.twilioRegion, code = _a.code;
                                return twilioRegion || code;
                            })
                                .map(function (_a) {
                                var twilioRegion = _a.twilioRegion, code = _a.code;
                                return twilioRegion || code;
                            })
                                .join(","));
                        }
                        testRunInfo.optimalRegion = optimalRegion;
                    };
                    if (!(testRunInfo.testConfig.region && !forceOptimalServerByPingAll)) return [3 /*break*/, 1];
                    if (testRunInfo.testConfig.datacenterRegionsMap) {
                        optimalRegionName_1 = testRunInfo.testConfig.datacenterRegionsMap[testRunInfo.testConfig.region.toUpperCase()];
                        console.log("LOG 2");
                        if (!optimalRegionName_1) {
                            throw new Error("URL requested region " + testRunInfo.testConfig.region + " unknown, valid regions are " + Object.keys(testRunInfo.testConfig.datacenterRegionsMap).join(","));
                        }
                        optimalRegion = testRunInfo.testConfig.datacenterRegions.find(function (_a) {
                            var code = _a.code;
                            return code === optimalRegionName_1;
                        });
                        console.log("LOG 3");
                        if (!optimalRegion) {
                            throw new Error("URL requested region [" + testRunInfo.testConfig.region + "] found in datacenterRegionsMap [" + optimalRegionName_1 + "] but not in datacenterRegions");
                        }
                        testRunInfo.optimalRegion = optimalRegion;
                        if (verbose) {
                            console.log("tests:GetAwsOptimalServer select by testConfig.options.region and datacenterRegionsMap", {
                                optimalRegion: testRunInfo.optimalRegion,
                            });
                        }
                    }
                    else {
                        findByRegionCode((_a = testRunInfo.testConfig.region) !== null && _a !== void 0 ? _a : "");
                        if (verbose) {
                            console.log("tests:GetAwsOptimalServer select by testConfig.options.region and datacenterRegions", {
                                optimalRegion: testRunInfo.optimalRegion,
                            });
                        }
                    }
                    return [3 /*break*/, 3];
                case 1:
                    if (!testRunInfo.testConfig.optimalServerByPingAll) return [3 /*break*/, 3];
                    return [4 /*yield*/, runPingTest(testRunInfo, true)];
                case 2:
                    pingResults = _c.sent();
                    if (!pingResults ||
                        !Array.isArray(pingResults) ||
                        pingResults.length < 1 ||
                        !pingResults[0].region) {
                        throw new Error("optimalServerByPingAll mode, not found ping results");
                    }
                    console.log("tests:GetAwsOptimalServer", { pingResults: pingResults });
                    findByRegionCode(pingResults[0].region);
                    if (verbose) {
                        console.log("tests:GetAwsOptimalServer select by ping all results", {
                            optimalRegion: testRunInfo.optimalRegion,
                        });
                    }
                    _c.label = 3;
                case 3:
                    if (!!testRunInfo.optimalRegion) return [3 /*break*/, 7];
                    config = testRunInfo.testConfig;
                    if (!config.CloudTestApi) {
                        throw new Error("GetAwsOptimalServer: Missing CloudTestApi");
                    }
                    url = (config.LatencyURL || config.CloudTestApi) + "/country";
                    if (!(config.datacenterRegions.length > 1)) return [3 /*break*/, 5];
                    return [4 /*yield*/, getUrl(url)];
                case 4:
                    _b = _c.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _b = config.datacenterRegions[0].code;
                    _c.label = 6;
                case 6:
                    regionCode_1 = _b;
                    if (!regionCode_1) {
                        throw new Error("GetAwsOptimalServer: query:" + config.CloudTestApi + "/country return empty");
                    }
                    optimalRegion = config.datacenterRegions.find(function (item) { return item.code === regionCode_1; });
                    if (!optimalRegion) {
                        throw new Error("GetAwsOptimalServer [" + regionCode_1 + "] not found in testConfig.datacenterRegions");
                    }
                    testRunInfo.logMessage("Optimal region " + optimalRegion.code + " " + optimalRegion.title);
                    testRunInfo.optimalRegion = optimalRegion;
                    if (verbose) {
                        if (config.datacenterRegions.length > 1) {
                            console.log("tests:GetAwsOptimalServer by query url:" + url + " -> " + regionCode_1 + " = " + (optimalRegion === null || optimalRegion === void 0 ? void 0 : optimalRegion.code));
                        }
                        else {
                            console.log("tests:GetAwsOptimalServer only one datacenterRegions -> " + regionCode_1 + " = " + (optimalRegion === null || optimalRegion === void 0 ? void 0 : optimalRegion.code));
                        }
                    }
                    _c.label = 7;
                case 7: return [2 /*return*/, testRunInfo.optimalRegion];
            }
        });
    });
}
function runTcpConnectivityTest(testRunInfo, testCredentials) {
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyLoadModule(function () { return import("./turn-connectivity-tcp"); })];
                case 1:
                    test = _a.sent();
                    return [2 /*return*/, test.run(testRunInfo.logMessage, testCredentials, testRunInfo.testConfig.customerName)];
            }
        });
    });
}
function runUdpConnectivityTest(testRunInfo, testCredentials) {
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyLoadModule(function () { return import("./turn-connectivity-udp"); })];
                case 1:
                    test = _a.sent();
                    return [2 /*return*/, test.run(testRunInfo.logMessage, testCredentials, testRunInfo.testConfig.customerName)];
            }
        });
    });
}
function runTlsConnectivityTest(testRunInfo, testCredentials) {
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyLoadModule(function () { return import("./turn-connectivity-tls"); })];
                case 1:
                    test = _a.sent();
                    return [2 /*return*/, test.run(testRunInfo.logMessage, testCredentials, testRunInfo.testConfig.customerName)];
            }
        });
    });
}
function runWssConnectivityTest(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var test, testRslt;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyLoadModule(function () { return import("./dns-lookup"); })];
                case 1:
                    test = _a.sent();
                    return [4 /*yield*/, test(testRunInfo, null, testRunInfo.testConfig.wssDomains)];
                case 2:
                    testRslt = _a.sent();
                    return [2 /*return*/, testRslt];
            }
        });
    });
}
function runSymmetricNatTest(testRunInfo, testCredentials) {
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyLoadModule(function () { return import("./turn-symmetric-nat"); })];
                case 1:
                    test = _a.sent();
                    return [2 /*return*/, test.run(testRunInfo.logMessage, testCredentials)];
            }
        });
    });
}
function getMediaServerIp(testRunInfo) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return __awaiter(this, void 0, void 0, function () {
        var netlifyBaseUrl, localIp, netlifyUrl, answer, onSuccess, err_6;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    netlifyBaseUrl = (_a = testRunInfo.testConfig.options.netlifyBaseUrl) !== null && _a !== void 0 ? _a : (IsLocalhost() ? "http://localhost:9000" : "");
                    localIp = (_c = (_b = testRunInfo.testResults.testCall) === null || _b === void 0 ? void 0 : _b.localAddress) === null || _c === void 0 ? void 0 : _c.split(":")[0];
                    netlifyUrl = netlifyBaseUrl + "/.netlify/functions/get-location?ipInsights=true&mediaServerIp=" + localIp + "&config=" + testRunInfo.testConfig.options.config;
                    if (!(localIp !== ((_d = testRunInfo.testResults.location) === null || _d === void 0 ? void 0 : _d.ip))) return [3 /*break*/, 4];
                    testRunInfo.logMessage("=== MEDIA SERVER IP [Location] ===");
                    if (testRunInfo.testConfig.location && !((_e = testRunInfo.testResults.location) === null || _e === void 0 ? void 0 : _e.error)) {
                        testRunInfo.testConfig.location.widgetType = "detailed";
                    }
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get(netlifyUrl)];
                case 2:
                    answer = _l.sent();
                    if ((_g = (_f = answer === null || answer === void 0 ? void 0 : answer.data) === null || _f === void 0 ? void 0 : _f.location) === null || _g === void 0 ? void 0 : _g.error) {
                        testRunInfo.logMessage({
                            stack: answer,
                            response: answer.data.location.error,
                        });
                        throw new Error("Can't find location");
                    }
                    onSuccess = function (location) {
                        var _a, _b;
                        if (location.isClientDefinedIp) {
                            var ip = location.ip;
                            var city = location.city;
                            var country = location.country_name;
                            var organization = "";
                            var coordinates = {
                                latitude: location.latitude,
                                longitude: location.longitude,
                            };
                            return {
                                ip: ip,
                                city: city,
                                country: country,
                                organization: organization,
                                coordinates: coordinates,
                            };
                        }
                        else {
                            var ip = location.traits.ipAddress;
                            var city = (_b = (_a = location.city) === null || _a === void 0 ? void 0 : _a.names) === null || _b === void 0 ? void 0 : _b.en;
                            var country = location.country.names.en;
                            var organization = location.traits.organization;
                            var coordinates = {
                                latitude: location.location.latitude,
                                longitude: location.location.longitude,
                            };
                            var traits = {
                                isAnonymousVpn: location.traits.isAnonymousVpn,
                                isHostingProvider: location.traits.isHostingProvider,
                                isPublicProxy: location.traits.isPublicProxy,
                                isTorExitNode: location.traits.isTorExitNode,
                                organization: location.traits.organization,
                                staticIpScore: location.traits.staticIpScore,
                                userCount: location.traits.userCount,
                                userType: location.traits.userType,
                            };
                            return {
                                ip: ip,
                                city: city,
                                country: country,
                                organization: organization,
                                coordinates: coordinates,
                                traits: traits,
                            };
                        }
                    };
                    if ((_h = testRunInfo.testResults.location) === null || _h === void 0 ? void 0 : _h.error) {
                        testRunInfo.testResults.location = onSuccess(answer.data.location);
                    }
                    return [2 /*return*/, onSuccess(answer.data.location)];
                case 3:
                    err_6 = _l.sent();
                    testRunInfo.logMessage({ stack: err_6.stack, response: err_6.response });
                    if ((_k = (_j = err_6.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.ip) {
                        testRunInfo.logMessage("Can't find location by ip: " + err_6.response.data.ip, "red");
                    }
                    throw new Error("Can't find location");
                case 4: return [2 /*return*/];
            }
        });
    });
}
function runThroughputTest(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var connectionName, testName, testCredentials, test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connectionName = GetConnectionInfoName(testRunInfo, TestNames.Throughput);
                    testName = "[Throughput" + (connectionName !== "twilio-testrtc-account" ? ":" + connectionName : "") + "]";
                    testRunInfo.logMessage("=== Throughput Test " + testName + " ===");
                    return [4 /*yield*/, GetTestCredentials2(TestNames.Throughput, testRunInfo)];
                case 1:
                    testCredentials = _a.sent();
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./throughput"); })];
                case 2:
                    test = _a.sent();
                    if (!test) {
                        console.log("tests:runThroughputTest", "MODULE NOT LOADED");
                    }
                    return [2 /*return*/, test === null || test === void 0 ? void 0 : test.run(testRunInfo, testCredentials)];
            }
        });
    });
}
function runTracerouteTest(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var domainNames, test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    domainNames = testRunInfo.testConfig.tracerouteTestDomains;
                    testRunInfo.logMessage(" === Traceroute Test [Traceroute] === ");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./Traceroute"); })];
                case 1:
                    test = _a.sent();
                    if (!test) {
                        console.log("tests:runThroughputTest", "MODULE NOT LOADED");
                    }
                    return [2 /*return*/, test(testRunInfo, domainNames)];
            }
        });
    });
}
function runTestCall(testRunInfo) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var test, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    testRunInfo.logMessage("=== Call Quality Test [CallQuality:twilio] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./twilio/twilio-call-quality"); })];
                case 1:
                    test = _g.sent();
                    if (!test) {
                        console.log("tests:runTestCall", "MODULE NOT LOADED");
                    }
                    if (!(test === null || test === void 0)) return [3 /*break*/, 2];
                    _c = void 0;
                    return [3 /*break*/, 4];
                case 2:
                    _e = (_d = test).run;
                    _f = [testRunInfo];
                    return [4 /*yield*/, GetCapabilityToken(testRunInfo, TestNames.CallQuality)];
                case 3:
                    _c = _e.apply(_d, _f.concat([_g.sent(), ((_a = testRunInfo.testConfig.options) === null || _a === void 0 ? void 0 : _a.audio) || ((_b = testRunInfo.testConfig["CallQuality"]) === null || _b === void 0 ? void 0 : _b.codec) || "Opus"]));
                    _g.label = 4;
                case 4: return [2 /*return*/, _c];
            }
        });
    });
}
function runTwilioVoiceCall(testRunInfo) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var test, testCredentials, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    testRunInfo.logMessage("=== Call Quality Test [CallQuality:twilio voice] ===");
                    return [4 /*yield*/, lazyLoadModule(function () {
                            return testRunInfo.testConfig.customerName === "voicetest"
                                ? import("./twilio/twilio-call-quality-voice-long")
                                : import("./twilio/twilio-call-quality-voice");
                        })];
                case 1:
                    test = _f.sent();
                    return [4 /*yield*/, GetTestCredentials2(TestNames.CallQuality, testRunInfo)];
                case 2:
                    testCredentials = _f.sent();
                    _d = (_c = test).run;
                    _e = [testRunInfo];
                    return [4 /*yield*/, GetCapabilityToken(testRunInfo, TestNames.CallQuality)];
                case 3: return [2 /*return*/, _d.apply(_c, _e.concat([_f.sent(), ((_a = testRunInfo.testConfig.options) === null || _a === void 0 ? void 0 : _a.audio) || ((_b = testRunInfo.testConfig["CallQuality"]) === null || _b === void 0 ? void 0 : _b.codec) || "Opus",
                        testCredentials]))];
            }
        });
    });
}
function runJsSIPCall(testRunInfo, connectionInfo) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    testRunInfo.logMessage("=== Call Quality Test [CallQuality:jssip] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./jssip/jssip-voice-quality"); })];
                case 1:
                    test = _c.sent();
                    return [2 /*return*/, test.run(testRunInfo, connectionInfo, ((_a = testRunInfo.testConfig.options) === null || _a === void 0 ? void 0 : _a.audio) || ((_b = testRunInfo.testConfig["CallQuality"]) === null || _b === void 0 ? void 0 : _b.codec) || "Opus")];
            }
        });
    });
}
var processLivevoxACDLogin = function (region) { return __awaiter(void 0, void 0, void 0, function () {
    var netlifyBaseUrl, url, data, response, err_7, errCode, errMsg, orgMsg;
    var _a, _b, _c, _d, _e, _f, _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                netlifyBaseUrl = IsLocalhost() ? "http://localhost:9000" : "";
                url = netlifyBaseUrl + "/.netlify/functions/livevox-acd-login";
                _h.label = 1;
            case 1:
                _h.trys.push([1, 3, , 4]);
                data = {
                    region: region,
                };
                return [4 /*yield*/, axios.post(url, IsLocalhost() ? JSON.stringify(data) : data)];
            case 2:
                response = _h.sent();
                if (response.status === 200) {
                    return [2 /*return*/, true];
                }
                else {
                    return [2 /*return*/, false];
                }
                return [3 /*break*/, 4];
            case 3:
                err_7 = _h.sent();
                errCode = ((_c = (_b = (_a = err_7) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.statusCode) || "";
                errMsg = ((_d = err_7) === null || _d === void 0 ? void 0 : _d.message) || "";
                orgMsg = ((_g = (_f = (_e = err_7) === null || _e === void 0 ? void 0 : _e.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.errMessage) || "";
                console.log("Failed to perform livevox-acd-login (Error : " + errCode + " " + errMsg + " " + orgMsg + ")");
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
function runLivevoxJsSIPCall(testRunInfo, connectionInfo) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var test, testResults, i, connectionInfoData, isSuccessful, result_1, result;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    testRunInfo.logMessage("=== Call Quality Test [CallQuality:jssip] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./jssip/jssip-voice-quality"); })];
                case 1:
                    test = _c.sent();
                    testResults = [];
                    i = 0;
                    _c.label = 2;
                case 2:
                    if (!(i <= connectionInfo.length - 1)) return [3 /*break*/, 7];
                    connectionInfoData = connectionInfo[i];
                    return [4 /*yield*/, processLivevoxACDLogin(connectionInfoData.region)];
                case 3:
                    isSuccessful = _c.sent();
                    if (!(isSuccessful === true)) return [3 /*break*/, 5];
                    return [4 /*yield*/, test.run(testRunInfo, { jssip: connectionInfoData }, ((_a = testRunInfo.testConfig.options) === null || _a === void 0 ? void 0 : _a.audio) ||
                            ((_b = testRunInfo.testConfig["CallQuality"]) === null || _b === void 0 ? void 0 : _b.codec) ||
                            "Opus")];
                case 4:
                    result_1 = _c.sent();
                    testResults.push(result_1);
                    return [3 /*break*/, 6];
                case 5:
                    console.log("livevox acd login for region:" + connectionInfoData.region + " failed");
                    _c.label = 6;
                case 6:
                    i++;
                    return [3 /*break*/, 2];
                case 7:
                    result = testResults.reduce(function (result, filter) {
                        if (result.mos1 > filter.mos1) {
                            return result;
                        }
                        else if (result.mos1 < filter.mos1) {
                            return filter;
                        }
                        else if (result.mos1 === filter.mos1) {
                            if (result.avgRtt > filter.avgRtt) {
                                return filter;
                            }
                            else {
                                return result;
                            }
                        }
                        else if (filter.mos1 == "N/A" && result.mos1) {
                            return result;
                        }
                        return filter;
                    }, {});
                    testRunInfo.intermidiatesResults.networkType = result.networkType;
                    return [2 /*return*/, result];
            }
        });
    });
}
function runGenesysVoiceCall(testRunInfo) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    testRunInfo.logMessage("=== Call Quality Test [CallQuality:Genesys] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./genesys/genesys-call-quality"); })];
                case 1:
                    test = _k.sent();
                    return [2 /*return*/, test.run(testRunInfo, (_c = (_b = (_a = testRunInfo.testConfig) === null || _a === void 0 ? void 0 : _a.CallQuality) === null || _b === void 0 ? void 0 : _b.genesysConfig) === null || _c === void 0 ? void 0 : _c.environment, (_f = (_e = (_d = testRunInfo.testConfig) === null || _d === void 0 ? void 0 : _d.CallQuality) === null || _e === void 0 ? void 0 : _e.genesysConfig) === null || _f === void 0 ? void 0 : _f.accessToken, (_j = (_h = (_g = testRunInfo.testConfig) === null || _g === void 0 ? void 0 : _g.CallQuality) === null || _h === void 0 ? void 0 : _h.genesysConfig) === null || _j === void 0 ? void 0 : _j.dialUpNum)];
            }
        });
    });
}
function runRingCentralVoiceCall(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    testRunInfo.logMessage("=== Call Quality Test [CallQuality:RingCentral] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./ringCentral/ringcentral-call-quality"); })];
                case 1:
                    test = _a.sent();
                    return [2 /*return*/, test.run(testRunInfo)];
            }
        });
    });
}
function runDialpadVoiceCall(testRunInfo, connectionInfo) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    testRunInfo.logMessage("=== Call Quality Test [CallQuality:jssip] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./jssip/jssip-voice-quality"); })];
                case 1:
                    test = _c.sent();
                    return [2 /*return*/, test.run(testRunInfo, { jssip: connectionInfo[0] }, ((_a = testRunInfo.testConfig.options) === null || _a === void 0 ? void 0 : _a.audio) || ((_b = testRunInfo.testConfig["CallQuality"]) === null || _b === void 0 ? void 0 : _b.codec) || "Opus")];
            }
        });
    });
}
function runCustomListDNSLookup(testRunInfo) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var test, testResults, i, result_2, callQualityRegion, result;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, lazyLoadModule(function () { return import("./dns-lookup"); })];
                case 1:
                    test = _d.sent();
                    testResults = [];
                    if (!(testRunInfo.testConfig.customDomains && testRunInfo.testConfig.customDomains.length)) return [3 /*break*/, 5];
                    i = 0;
                    _d.label = 2;
                case 2:
                    if (!(i <= testRunInfo.testConfig.customDomains.length - 1)) return [3 /*break*/, 5];
                    testRunInfo.testConfig.domains = testRunInfo.testConfig.customDomains[i]["domains"];
                    return [4 /*yield*/, test(testRunInfo, testRunInfo.testConfig.customDomains[i]["region"])];
                case 3:
                    result_2 = _d.sent();
                    testResults.push(result_2);
                    _d.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 2];
                case 5:
                    callQualityRegion = ((_a = testRunInfo.testResults.testCall) === null || _a === void 0 ? void 0 : _a.region) ||
                        ((_b = testRunInfo.testConfig) === null || _b === void 0 ? void 0 : _b.region) ||
                        ((_c = testRunInfo.testConfig.options) === null || _c === void 0 ? void 0 : _c.region) ||
                        "";
                    result = testResults.find(function (x) { return x.region.toLowerCase() === callQualityRegion.toLowerCase(); });
                    return [2 /*return*/, result];
            }
        });
    });
}
function runSpeedTest(testRunInfo) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var testAllServers, connectionName, optimalServer, findByRegionCode, _e, bandwidthTestConfig, pingUrls, pingResults, i, _f, ping, url, speed, testUrls, result;
        var _this = this;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    testAllServers = (_a = testRunInfo.testConfig.BandwidthSpeed) === null || _a === void 0 ? void 0 : _a.all;
                    connectionName = GetConnectionInfoName(testRunInfo, TestNames.BandwidthSpeed);
                    if (!(connectionName === "genesys")) return [3 /*break*/, 2];
                    findByRegionCode = function (regionCode) { return __awaiter(_this, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    optimalServer = testRunInfo.testConfig.datacenterRegions.find(function (x) { var _a; return ((_a = x === null || x === void 0 ? void 0 : x.code) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (regionCode === null || regionCode === void 0 ? void 0 : regionCode.toLowerCase()); });
                                    if (!!optimalServer) return [3 /*break*/, 4];
                                    if (!!testAllServers) return [3 /*break*/, 2];
                                    return [4 /*yield*/, GetAwsOptimalServer(testRunInfo)];
                                case 1:
                                    _a = _b.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    _a = undefined;
                                    _b.label = 3;
                                case 3:
                                    optimalServer = _a;
                                    return [3 /*break*/, 5];
                                case 4:
                                    // above if statement if called will already assign the value to testRunInfo.optimalRegion
                                    testRunInfo.optimalRegion = optimalServer;
                                    _b.label = 5;
                                case 5:
                                    console.log("subham:tests:runSpeedTest:Genesys select by testConfig.options.mediaRegion and datacenterRegions", {
                                        optimalRegion: testRunInfo.optimalRegion,
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    return [4 /*yield*/, findByRegionCode((_b = testRunInfo.testConfig.options.mediaRegion) !== null && _b !== void 0 ? _b : "")];
                case 1:
                    _g.sent();
                    return [3 /*break*/, 6];
                case 2:
                    if (!!testAllServers) return [3 /*break*/, 4];
                    return [4 /*yield*/, GetAwsOptimalServer(testRunInfo)];
                case 3:
                    _e = _g.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _e = undefined;
                    _g.label = 5;
                case 5:
                    optimalServer = _e;
                    _g.label = 6;
                case 6:
                    bandwidthTestConfig = testRunInfo.testConfig.BandwidthSpeed;
                    // const speedUnits = testRunInfo.testConfig.useMebibits ? "mibps" : "mbps";
                    testRunInfo.logMessage("=== Bandwidth Speed " + (testAllServers ? "All" : "Best") + " Test [BandwidthSpeed:" + (testAllServers ? "all" : "best:" + optimalServer.code) + "] ===");
                    pingUrls = [];
                    pingResults = (_d = (_c = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testResults) === null || _c === void 0 ? void 0 : _c.pingTest) === null || _d === void 0 ? void 0 : _d.all;
                    if (pingResults && Array.isArray(pingResults)) {
                        for (i = 0; i < pingResults.length; i++) {
                            _f = pingResults[i], ping = _f.ping, url = _f.url;
                            if (ping != -1 && url) {
                                pingUrls.push(url);
                                break;
                            }
                        }
                        pingUrls.push();
                    }
                    // check if there is customer specific parameters
                    if (bandwidthTestConfig === null || bandwidthTestConfig === void 0 ? void 0 : bandwidthTestConfig.countPing) {
                        testRunInfo.testConfig.countPing = bandwidthTestConfig.countPing;
                    }
                    if (bandwidthTestConfig === null || bandwidthTestConfig === void 0 ? void 0 : bandwidthTestConfig.timeDl) {
                        testRunInfo.testConfig.timeDl = bandwidthTestConfig.timeDl;
                    }
                    if (bandwidthTestConfig === null || bandwidthTestConfig === void 0 ? void 0 : bandwidthTestConfig.timeUl) {
                        testRunInfo.testConfig.timeUl = bandwidthTestConfig.timeUl;
                    }
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./speed"); })];
                case 7:
                    speed = _g.sent();
                    testUrls = pingUrls.length > 0
                        ? pingUrls
                        : testAllServers
                            ? testRunInfo.speedTestUrls
                            : Array.isArray(optimalServer.url)
                                ? optimalServer.url
                                : [optimalServer.url];
                    if (testRunInfo.testConfig.verbose) {
                        console.log("tests:runSpeedTest", {
                            pingUrls: pingUrls,
                            testUrls: testUrls,
                        });
                    }
                    if (!speed) {
                        console.log("tests:runSpeedTest", "MODULE NOT LOADED");
                    }
                    return [4 /*yield*/, (speed === null || speed === void 0 ? void 0 : speed.run(testRunInfo.logMessage, testRunInfo.logSpeedMessage, testRunInfo.testConfig, testUrls, testRunInfo.testConfig.verbose))];
                case 8:
                    result = _g.sent();
                    result = parseRegions(testRunInfo, result);
                    result.sort(function (a, b) {
                        return (a.download < 0 ? 9999 : a.download) - (b.download < 0 ? 9999 : b.download);
                    });
                    if (!testAllServers) {
                        testRunInfo.logMessage(result[0]);
                    }
                    // testRunInfo.logMessage(`=== Bandwidth Speed ${testAllServers ? "All" : "Best"} End ===`);
                    return [2 /*return*/, testAllServers ? result : result[0]];
            }
        });
    });
}
function runPingTest(testRunInfo, forceTestAllServers) {
    var _a, _b, _c, _d, _e, _f;
    if (forceTestAllServers === void 0) { forceTestAllServers = false; }
    return __awaiter(this, void 0, void 0, function () {
        var forceOptimalServerByPingAll, connectionName, testAllServers, optimalServer, _g, callQualityRegion, config, callQualityPingRegion, pingTestUrls, ping, i, result, callTest_ping, finalResult;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    forceOptimalServerByPingAll = false;
                    connectionName = GetConnectionInfoName(testRunInfo, TestNames.Ping);
                    // in case of ping test force finding optimal server by ping all
                    // not changing in GetAwsOptimalServer since used at many places
                    // pass flag to direct flow
                    if (connectionName === "genesys")
                        forceOptimalServerByPingAll = true;
                    testAllServers = forceTestAllServers || ((_a = testRunInfo.testConfig.Ping) === null || _a === void 0 ? void 0 : _a.all);
                    if (!!forceTestAllServers) return [3 /*break*/, 2];
                    return [4 /*yield*/, GetAwsOptimalServer(testRunInfo, forceOptimalServerByPingAll)];
                case 1:
                    _g = _h.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _g = null;
                    _h.label = 3;
                case 3:
                    optimalServer = _g;
                    callQualityRegion = (_d = (_c = (_b = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testResults) === null || _b === void 0 ? void 0 : _b.testCall) === null || _c === void 0 ? void 0 : _c.region) === null || _d === void 0 ? void 0 : _d.toLowerCase();
                    config = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testConfig;
                    callQualityPingRegion = callQualityRegion
                        ? config.datacenterRegions.find(function (x) { return x.title.toLowerCase().includes(callQualityRegion !== null && callQualityRegion !== void 0 ? callQualityRegion : ""); })
                        : undefined;
                    if (!config.ping) {
                        throw new Error("Ping list not configured, use pairsList or allList");
                    }
                    pingTestUrls = [];
                    config === null || config === void 0 ? void 0 : config.datacenterRegions.filter(function (item) {
                        if (!item.url) {
                            return false;
                        }
                        if (config.ping.pairsList && optimalServer) {
                            return (config.ping.pairsList[optimalServer.code] &&
                                config.ping.pairsList[optimalServer.code].indexOf(item.code) >= 0);
                        }
                        if (config.ping.allList) {
                            return ((!optimalServer || optimalServer.code !== item.code) &&
                                config.ping.allList.indexOf(item.code) >= 0);
                        }
                        return true;
                    }).forEach(function (item) {
                        var url = item.url;
                        if (Array.isArray(url)) {
                            for (var i = 0; i < url.length; i++) {
                                pingTestUrls.push(url[i]);
                            }
                        }
                        else {
                            pingTestUrls.push(url);
                        }
                    });
                    if (!forceTestAllServers) {
                        testRunInfo.logMessage("=== Ping " + (testAllServers ? "All" : "Best") + " Test [Ping:" + (testAllServers ? "all" : "best") + "] ===");
                    }
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./ping"); })];
                case 4:
                    ping = _h.sent();
                    if (optimalServer) {
                        if (Array.isArray(optimalServer.url)) {
                            for (i = 0; i < optimalServer.url.length; i++) {
                                pingTestUrls.push(optimalServer.url[i]);
                            }
                        }
                        else {
                            pingTestUrls.push(optimalServer.url);
                        }
                    }
                    if (!ping.run) {
                        throw new Error("Unable to load the required module properly due to a network issue. Please try again, and if the issue persists, please contact our support team for further assistance.");
                    }
                    return [4 /*yield*/, ping.run(testRunInfo.logMessage, testRunInfo.logPingMessage, config, testAllServers ? pingTestUrls : [optimalServer.url], testRunInfo.loggingLevel)];
                case 5:
                    result = _h.sent();
                    callTest_ping = {};
                    if (!callQualityPingRegion) return [3 /*break*/, 7];
                    return [4 /*yield*/, ping.run(testRunInfo.logMessage, testRunInfo.logPingMessage, config, [callQualityPingRegion.url], testRunInfo.loggingLevel)];
                case 6:
                    callTest_ping = _h.sent();
                    _h.label = 7;
                case 7:
                    result.sort(function (a, b) {
                        TestNames;
                        return (a.ping < 0 ? 9999 : a.ping) - (b.ping < 0 ? 9999 : b.ping);
                    });
                    if (!forceTestAllServers) {
                        // testRunInfo.logMessage(`=== Ping ${testAllServers ? "All" : "Best"} End ===`);
                    }
                    else {
                        testRunInfo.logMessage("Ping all best result is " + ((_e = result[0]) === null || _e === void 0 ? void 0 : _e.url) + " " + ((_f = result[0]) === null || _f === void 0 ? void 0 : _f.ping) + "ms");
                    }
                    finalResult = testAllServers ? result : result[0];
                    testRunInfo.testResults["callTest_ping"] = callTest_ping[0];
                    return [2 /*return*/, finalResult];
            }
        });
    });
}
function runConectivityTest(testRunInfo) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function () {
        var verbose, connectionName, testName, testCredentials, disableProtocols, isWssEnabled, tcpTestRes, udpTestRes, tlsTestRes, wssTestRes, symmetricNatTestRes, behindProxy, errorsCount;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    verbose = testRunInfo.testConfig.verbose;
                    connectionName = GetConnectionInfoName(testRunInfo, TestNames.TurnConnectivity);
                    testName = "[TurnConnectivity" + (connectionName !== "twilio-testrtc-account" ? ":" + connectionName : "") + "]";
                    testRunInfo.logMessage("=== TURN Connectivity Test " + testName + " ===");
                    return [4 /*yield*/, GetTestCredentials2(TestNames.TurnConnectivity, testRunInfo)];
                case 1:
                    testCredentials = _g.sent();
                    if (verbose) {
                        console.log("tests:runConectivityTest", {
                            testCredentials: testCredentials,
                        });
                    }
                    disableProtocols = (_b = (_a = testRunInfo.testConfig) === null || _a === void 0 ? void 0 : _a.TurnConnectivity) === null || _b === void 0 ? void 0 : _b.disableProtocols;
                    isWssEnabled = (_d = (_c = testRunInfo.testConfig) === null || _c === void 0 ? void 0 : _c.TurnConnectivity) === null || _d === void 0 ? void 0 : _d.enableWss;
                    tcpTestRes = {};
                    udpTestRes = {};
                    tlsTestRes = {};
                    wssTestRes = {};
                    symmetricNatTestRes = {};
                    if (!(!disableProtocols || disableProtocols.indexOf("tcp") == -1)) return [3 /*break*/, 3];
                    return [4 /*yield*/, runTcpConnectivityTest(testRunInfo, testCredentials)];
                case 2:
                    tcpTestRes = _g.sent();
                    _g.label = 3;
                case 3:
                    if (!(!disableProtocols || disableProtocols.indexOf("udp") == -1)) return [3 /*break*/, 5];
                    return [4 /*yield*/, runUdpConnectivityTest(testRunInfo, testCredentials)];
                case 4:
                    udpTestRes = _g.sent();
                    _g.label = 5;
                case 5:
                    if (!(!disableProtocols || disableProtocols.indexOf("tls") == -1)) return [3 /*break*/, 7];
                    return [4 /*yield*/, runTlsConnectivityTest(testRunInfo, testCredentials)];
                case 6:
                    tlsTestRes = _g.sent();
                    _g.label = 7;
                case 7:
                    if (!isWssEnabled) return [3 /*break*/, 9];
                    return [4 /*yield*/, runWssConnectivityTest(testRunInfo)];
                case 8:
                    wssTestRes = _g.sent();
                    _g.label = 9;
                case 9:
                    if (!((_f = (_e = testRunInfo.testConfig) === null || _e === void 0 ? void 0 : _e.TurnConnectivity) === null || _f === void 0 ? void 0 : _f.SymmetricNat)) return [3 /*break*/, 11];
                    return [4 /*yield*/, runSymmetricNatTest(testRunInfo, testCredentials)];
                case 10:
                    symmetricNatTestRes = _g.sent();
                    _g.label = 11;
                case 11:
                    behindProxy = Utils.isBehindProxy();
                    testRunInfo.logMessage({ behindProxy: behindProxy });
                    errorsCount = 0;
                    if (tcpTestRes.tcpError) {
                        errorsCount++;
                    }
                    if (udpTestRes.udpError) {
                        errorsCount++;
                    }
                    if (tlsTestRes.tlsError) {
                        errorsCount++;
                    }
                    return [2 /*return*/, __assign(__assign(__assign(__assign(__assign(__assign({}, tcpTestRes), udpTestRes), tlsTestRes), wssTestRes), symmetricNatTestRes), { behindProxy: behindProxy, meta: { errorsCount: errorsCount } })];
            }
        });
    });
}
function runConectivityTest2(testRunInfo) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var connectionName, testConfig, useConnectionOverrideConfig, testName, testCredentials, disableProtocols, tcpTestRes, udpTestRes, tlsTestRes, behindProxy, errorsCount;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    connectionName = GetConnectionInfoName(testRunInfo, TestNames.TurnConnectivity2);
                    testConfig = testRunInfo.testConfig[TestNames.TurnConnectivity2.toString()];
                    useConnectionOverrideConfig = testConfig === null || testConfig === void 0 ? void 0 : testConfig.connectionOverrideIceServers;
                    testName = "[TurnConnectivity" + (connectionName !== "twilio-testrtc-account" ? ":" + connectionName : "") + "]";
                    testRunInfo.logMessage("=== TURN Connectivity Test " + testName + " ===");
                    if (!useConnectionOverrideConfig) return [3 /*break*/, 1];
                    if (testRunInfo.intermidiatesResults["RTCIceServers"]) {
                        testCredentials = testRunInfo.intermidiatesResults["RTCIceServers"];
                    }
                    else {
                        throw new Error("connectionOverrideIceServers=true, Missing connection RTCIceServers");
                    }
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, GetTestCredentials2(TestNames.TurnConnectivity2, testRunInfo)];
                case 2:
                    testCredentials = _c.sent();
                    _c.label = 3;
                case 3:
                    disableProtocols = (_b = (_a = testRunInfo.testConfig) === null || _a === void 0 ? void 0 : _a.TurnConnectivity2) === null || _b === void 0 ? void 0 : _b.disableProtocols;
                    tcpTestRes = {};
                    udpTestRes = {};
                    tlsTestRes = {};
                    if (!(!disableProtocols || disableProtocols.indexOf("tcp") == -1)) return [3 /*break*/, 5];
                    return [4 /*yield*/, runTcpConnectivityTest(testRunInfo, testCredentials)];
                case 4:
                    tcpTestRes = _c.sent();
                    _c.label = 5;
                case 5:
                    if (!(!disableProtocols || disableProtocols.indexOf("udp") == -1)) return [3 /*break*/, 7];
                    return [4 /*yield*/, runUdpConnectivityTest(testRunInfo, testCredentials)];
                case 6:
                    udpTestRes = _c.sent();
                    _c.label = 7;
                case 7:
                    if (!(!disableProtocols || disableProtocols.indexOf("tls") == -1)) return [3 /*break*/, 9];
                    return [4 /*yield*/, runTlsConnectivityTest(testRunInfo, testCredentials)];
                case 8:
                    tlsTestRes = _c.sent();
                    _c.label = 9;
                case 9:
                    behindProxy = Utils.isBehindProxy();
                    testRunInfo.logMessage({ behindProxy: behindProxy });
                    errorsCount = 0;
                    if (tcpTestRes.tcpError) {
                        errorsCount++;
                    }
                    if (udpTestRes.udpError) {
                        errorsCount++;
                    }
                    if (tlsTestRes.tlsError) {
                        errorsCount++;
                    }
                    return [2 /*return*/, __assign(__assign(__assign(__assign({}, tcpTestRes), udpTestRes), tlsTestRes), { behindProxy: behindProxy, meta: { errorsCount: errorsCount } })];
            }
        });
    });
}
function runDNSSetupTest(testRunInfo) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var pingAll, optimalServer, foundOptimalServer, msg;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    testRunInfo.logMessage("=== DNS Setup Test [DNSSetup] ===");
                    pingAll = [];
                    if (!(testRunInfo.testResults.pingTest && testRunInfo.testResults.pingTest.all)) return [3 /*break*/, 1];
                    pingAll = (_b = (_a = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testResults) === null || _a === void 0 ? void 0 : _a.pingTest) === null || _b === void 0 ? void 0 : _b.all;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, runPingTest(testRunInfo, true)];
                case 2:
                    pingAll = _e.sent();
                    _e.label = 3;
                case 3: return [4 /*yield*/, GetAwsOptimalServer(testRunInfo)];
                case 4:
                    optimalServer = _e.sent();
                    foundOptimalServer = Array.isArray(pingAll)
                        ? pingAll.find(function (x) { return x.region === optimalServer.title; })
                        : false;
                    if (!foundOptimalServer) {
                        msg = "Cannot find optimal server " + JSON.stringify(optimalServer) + " in list of ping all results";
                        testRunInfo.logMessage(msg, "red");
                        console.log("runDNSSetupTest " + msg, {
                            pingAll: pingAll,
                            optimalServer: optimalServer,
                            foundOptimalServer: foundOptimalServer,
                        });
                    }
                    else {
                        if (foundOptimalServer.ping - pingAll[0].ping > 10) {
                            testRunInfo.logMessage("Data center selected might not be optimal", "red");
                            testRunInfo.logMessage("DNS Answer: " + optimalServer.title + " (" + foundOptimalServer.ping + "ms) is slower than best ping (" + pingAll[0].ping + "ms) results by " + (((foundOptimalServer.ping - pingAll[0].ping) / pingAll[0].ping) *
                                100).toFixed(0) + "%, <a href=\"" + ((_d = (_c = testRunInfo === null || testRunInfo === void 0 ? void 0 : testRunInfo.testConfig) === null || _c === void 0 ? void 0 : _c.knowledgeUrl) === null || _d === void 0 ? void 0 : _d.BadDNSResolution) + "\">read more here</a>");
                            return [2 /*return*/, { error: "Data center selected might not be optimal" }];
                        }
                    }
                    // testRunInfo.logMessage("=== DNS Setup End ===");
                    return [2 /*return*/, {}];
            }
        });
    });
}
function runVideoP2PTest(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var connectionName, connectionInfo, test, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    testRunInfo.logMessage("=== VideoP2P Test [VideoP2P] ===");
                    connectionName = GetConnectionInfoName(testRunInfo, TestNames.VideoP2P);
                    return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                            connectionName: connectionName,
                        })];
                case 1:
                    connectionInfo = _a.sent();
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./video-p2p"); })];
                case 2:
                    test = _a.sent();
                    return [4 /*yield*/, test(testRunInfo, connectionInfo)];
                case 3:
                    result = _a.sent();
                    logResults(testRunInfo.logMessage, result);
                    // testRunInfo.logMessage("=== VideoP2P Test End ===");
                    return [2 /*return*/, result];
            }
        });
    });
}
function runNiceInContactCallQualityTest(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    testRunInfo.logMessage("=== Call Quality Test [CallQuality:niceincontact] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./nice/nice-call-quality"); })];
                case 1:
                    test = _a.sent();
                    return [4 /*yield*/, test(testRunInfo, "nice")];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function runPuzzelCallQualityTest(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    testRunInfo.logMessage("=== Call Quality Test [CallQuality:Puzzel] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./puzzel/puzzel-call-quality"); })];
                case 1:
                    test = _a.sent();
                    return [4 /*yield*/, test(testRunInfo, "puzzel")];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function runVideoBandwidthTest(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var testCredentials, test, answer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetTestCredentials2(TestNames.VideoBandwidth, testRunInfo)];
                case 1:
                    testCredentials = _a.sent();
                    testRunInfo.logMessage("=== Video Bandwidth Test [VideoBandwidth] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./video-bandwidth"); })];
                case 2:
                    test = _a.sent();
                    return [4 /*yield*/, test.run(testRunInfo, testCredentials)];
                case 3:
                    answer = _a.sent();
                    return [2 /*return*/, answer];
            }
        });
    });
}
function runVideoBandwidthTest2(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var connectionName, testCredentials, test, answer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connectionName = GetConnectionInfoName(testRunInfo, TestNames.VideoBandwidth2);
                    return [4 /*yield*/, GetTestCredentials2(TestNames.VideoBandwidth2, testRunInfo)];
                case 1:
                    testCredentials = _a.sent();
                    testRunInfo.logMessage("=== Video Bandwidth Test [" + connectionName + "] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./video-bandwidth"); })];
                case 2:
                    test = _a.sent();
                    return [4 /*yield*/, test.run(testRunInfo, testCredentials)];
                case 3:
                    answer = _a.sent();
                    return [2 /*return*/, answer];
            }
        });
    });
}
function runPrivateConnectionsTests(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    testRunInfo.logMessage("=== Private Connections Test [PrivateConnections] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./private-connections"); })];
                case 1:
                    test = _a.sent();
                    return [2 /*return*/, test(testRunInfo)];
            }
        });
    });
}
function runDeviceStateTests(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    testRunInfo.logMessage("=== Device State Test [DeviceState] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./deviceState"); })];
                case 1:
                    test = _a.sent();
                    return [2 /*return*/, test(testRunInfo)];
            }
        });
    });
}
function runVideoQualityTest(testRunInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var connectionName, mediaMode, connectionInfo, test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connectionName = GetConnectionInfoName(testRunInfo, TestNames.VideoQuality);
                    mediaMode = connectionName === "tokbox" || connectionName === "tokbox-gestats" ? "routed" : undefined;
                    return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                            connectionName: connectionName,
                            mediaMode: mediaMode,
                        })];
                case 1:
                    connectionInfo = _a.sent();
                    if (!(connectionName === "itracks")) return [3 /*break*/, 3];
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:itracks] ===");
                    return [4 /*yield*/, lazyLoadModule(function () {
                            return import("./frozenmountain/frozenmountain-video-quality");
                        })];
                case 2:
                    test = test = _a.sent();
                    return [3 /*break*/, 32];
                case 3:
                    if (!(connectionName === "liveswitch")) return [3 /*break*/, 5];
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:liveswitch] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./liveswitch/liveswitch-video-quality"); })];
                case 4:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 5:
                    if (!(connectionName === "pexip")) return [3 /*break*/, 7];
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:pexip] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./pexip/pexip-video-quality"); })];
                case 6:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 7:
                    if (!(connectionName === "intelOWT")) return [3 /*break*/, 9];
                    testRunInfo.logMessage("=== Intel Video Quality Test [VideoQuality:intelOWT] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./intelOWT/intelOWT-video-quality"); })];
                case 8:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 9:
                    if (!(connectionName === "tokbox")) return [3 /*break*/, 11];
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:tokbox] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./tokbox/tokbox-video-quality-with-getstats"); })];
                case 10:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 11:
                    if (!(connectionName === "talview")) return [3 /*break*/, 13];
                    testRunInfo.logMessage("=== Talview Video Quality Test [VideoQuality:Talview] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./talview/talview-video-quality"); })];
                case 12:
                    test = _a.sent();
                    console.log("tests:runVideoQualityTest", { connectionInfo: connectionInfo });
                    return [3 /*break*/, 32];
                case 13:
                    if (!(connectionName === "logitech")) return [3 /*break*/, 15];
                    testRunInfo.logMessage("=== Logitech Video Quality Test [VideoQuality:logitech] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./logitech/logitech-video-quality"); })];
                case 14:
                    test = _a.sent();
                    console.log("tests:runVideoQualityTest", { connectionInfo: connectionInfo });
                    return [3 /*break*/, 32];
                case 15:
                    if (!(connectionName === "avaya")) return [3 /*break*/, 17];
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:avaya] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./avaya/avaya-video-quality"); })];
                case 16:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 17:
                    if (!(connectionName === "agora")) return [3 /*break*/, 19];
                    testRunInfo.logMessage("=== Agora Video Quality Test [VideoQuality:Agora] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./agora/agora-video-quality"); })];
                case 18:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 19:
                    if (!(connectionName === "webex")) return [3 /*break*/, 21];
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:webex] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./webex/webex-video-quality"); })];
                case 20:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 21:
                    if (!(connectionName === "erizo")) return [3 /*break*/, 23];
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:erizo] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./erizo/erizo-video-quality"); })];
                case 22:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 23:
                    if (!(connectionInfo && connectionInfo.provider === "openvidu")) return [3 /*break*/, 25];
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:openvidu] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./openvidu/openvidu-video-quality"); })];
                case 24:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 25:
                    if (!(connectionInfo && connectionInfo.provider === "janus")) return [3 /*break*/, 27];
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:janus] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./janus/janus-video-quality"); })];
                case 26:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 27:
                    if (!(connectionInfo && connectionInfo.provider === "chime")) return [3 /*break*/, 29];
                    //added it only for QualityRTC  keep outside  for  qualitrtc SDK
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:chime] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./chime/chime-video-quality"); })];
                case 28:
                    test = _a.sent();
                    return [3 /*break*/, 32];
                case 29:
                    if (!(connectionInfo &&
                        (connectionInfo.provider === "twilio-group" || connectionInfo.provider === "twilio"))) return [3 /*break*/, 31];
                    testRunInfo.logMessage("=== Video Quality Test [VideoQuality:twilio] ===");
                    return [4 /*yield*/, lazyLoadModule(function () { return import("./twilio/twilio-video-quality"); })];
                case 30:
                    test = _a.sent();
                    console.log("tests:runVideoQualityTest", { connectionInfo: connectionInfo });
                    return [3 /*break*/, 32];
                case 31:
                    console.log("VideoQuality not implemented for", {
                        connectionInfo: connectionInfo,
                        connectionName: connectionName,
                        testRunInfo: testRunInfo,
                    });
                    return [2 /*return*/, {
                            error: "VideoQuality not implemented for " + connectionInfo.provider + " provider",
                        }];
                case 32: return [2 /*return*/, test(testRunInfo, connectionInfo)];
            }
        });
    });
}
var setResults = function (testResults, resultName, value) {
    var _a;
    if (resultName.includes(".")) {
        var parts = resultName.split(".");
        testResults[parts[0]] = __assign(__assign({}, testResults[parts[0]]), (_a = {}, _a[parts[1]] = value, _a));
    }
    else {
        testResults[resultName] = value;
    }
};
var isFunction = function (func) {
    return typeof func === "function";
};
var getBackgroundTime = function () {
    if (inactiveAt) {
        var totalTime = (Date.now() - inactiveAt) / 1000;
        inactiveAt = null;
        timeInBackground = totalTime + timeInBackground;
        return timeInBackground;
    }
    else {
        return timeInBackground;
    }
};
// Get the Background Time for each Test https://redmine.testrtc.com/issues/10131#note-3
var getTestBackgroundTime = function () {
    if (testInactiveAt) {
        var testTotalTime = (Date.now() - testInactiveAt) / 1000;
        testTimeInBackground = testTotalTime + testTimeInBackground;
        return testTimeInBackground;
    }
    else {
        return testTimeInBackground;
    }
};
var logBackgroundTime = function (event) {
    if (document.visibilityState === "hidden") {
        inactiveAt = Date.now();
        testInactiveAt = Date.now();
    }
    else if (document.visibilityState === "visible") {
        if (inactiveAt) {
            var totalTime = timeInBackground + (Date.now() - inactiveAt) / 1000;
            inactiveAt = null;
            timeInBackground = totalTime;
        }
        if (testInactiveAt) {
            var testTotalTime = testTimeInBackground + (Date.now() - testInactiveAt) / 1000;
            testInactiveAt = null;
            testTimeInBackground = testTotalTime;
        }
    }
};
// Reset the Test Background Time
var resetTestBackgroundTime = function () {
    testTimeInBackground = 0;
    testInactiveAt ? (testInactiveAt = Date.now()) : (testInactiveAt = null);
};
var requestWakeLock = function () {
    if (wakeLock === null) {
        navigator.wakeLock
            .request("screen")
            .then(function (lock) {
            wakeLock = lock;
            console.log("WakeLock invoked.");
        })
            .catch(function (error) {
            console.error("Failed to request screen wake lock:", error);
        });
    }
};
var releaseWakeLock = function () {
    if (wakeLock !== null) {
        wakeLock
            .release()
            .then(function () {
            wakeLock = null;
            console.log("WakeLock released.");
        })
            .catch(function (error) {
            console.error("Failed to release screen wake lock:", error);
        });
    }
};
export var runAllTests = function (externalLogMessage, logPingMessage, logSpeedMessage, config, testsList, finishOneTestFn) { return __awaiter(void 0, void 0, void 0, function () {
    // function for listening browser visibility event and log time;
    function saveLogs(args) {
        var stringifiedArgs = args
            .map(function (arg) {
            if (typeof arg === "string") {
                return arg.trim();
            }
            try {
                return JSON.stringify(arg);
            }
            catch (err) {
                // There is some kind of circular dependency in the `arg` object
                // let's log at least "shape" of the object
                var oneLevelArg = {};
                for (var _i = 0, _a = Object.entries(arg); _i < _a.length; _i++) {
                    var _b = _a[_i], key = _b[0], value = _b[1];
                    if (typeof value === "function") {
                        oneLevelArg[key] = "[Function]";
                        continue;
                    }
                    if (value && typeof value === "object") {
                        oneLevelArg[key] = "[Object]";
                        continue;
                    }
                    oneLevelArg[key] = value;
                }
                return JSON.stringify(oneLevelArg);
            }
        })
            .join(" ");
        consoleLog.push(stringifiedArgs);
    }
    var consoleLog, oldConsoleLog, oldConsoleWarn, oldConsoleError, oldConsoleGroup, oldConsoleInfo, logMessage, testConfig, fingerPrintMaker, fingerPrint, speedTestUrls, utcString, timeOffset, timeZoneMessage, setTestStatus, testResults, testStatuses, actualEstimate, testRunInfo, canceled, checkBrowserTest, checkBrowserVersionTest, checkVersion, _a, checkBrowser, availableTests, testsData, getEstimatedTime_1, totalEstimate, passedFromStart, testRunningIdx, _loop_1, _i, testsData_1, testData, totalTimeInBackground, result;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                consoleLog = [];
                oldConsoleLog = console.log;
                oldConsoleWarn = console.warn;
                oldConsoleError = console.error;
                oldConsoleGroup = console.group;
                oldConsoleInfo = console.info;
                // initialize total time in background to fix the time error of running the test without refreshing the page
                timeInBackground = 0;
                document.addEventListener("visibilitychange", logBackgroundTime); // listen to the event when browser visibility changes
                if (config.verbose) {
                    console.log = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        oldConsoleLog.apply(void 0, args);
                        saveLogs(args);
                    };
                    console.group = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        oldConsoleGroup.apply(void 0, args);
                        saveLogs(args);
                    };
                    console.info = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        oldConsoleInfo.apply(void 0, args);
                        saveLogs(args);
                    };
                    console.warn = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        oldConsoleWarn.apply(void 0, args);
                        saveLogs(args);
                    };
                    console.error = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        oldConsoleError.apply(void 0, args);
                        saveLogs(args);
                    };
                }
                //conditions to active wakelocak as mentioned in ticket
                // https://redmine.testrtc.com/issues/8932
                if ("wakeLock" in navigator) {
                    if ((config.isProbe && config.options.wakeLock) ||
                        (!config.isProbe && (config.wakeLock === true || !("wakeLock" in config)))) {
                        // Screen Wake Lock API is supported
                        requestWakeLock();
                    }
                }
                logMessage = function (message, color, isSystemMessage) {
                    if (config.verbose) {
                        if (typeof message === "string") {
                            console.log("LOG: " + message);
                        }
                        else {
                            console.log("LOG: " + JSON.stringify(message));
                        }
                    }
                    externalLogMessage(message, color, isSystemMessage);
                };
                if (config.fakeResults) {
                    return [2 /*return*/, config.fakeResults];
                }
                if ((config === null || config === void 0 ? void 0 : config.options) && (config === null || config === void 0 ? void 0 : config.options[""]) && (config === null || config === void 0 ? void 0 : config.options[""]) == "undefined") {
                    delete config.options[""];
                }
                if ((config === null || config === void 0 ? void 0 : config.options) && Object.keys(config === null || config === void 0 ? void 0 : config.options).length != 0) {
                    // if connection is of Genesys, do not print URL query parameters they have sensitive info in options field.
                    if ((config === null || config === void 0 ? void 0 : config.ConnectionInfoName) !== "genesys") {
                        logMessage({
                            "URL query parameters": config === null || config === void 0 ? void 0 : config.options,
                        });
                    }
                }
                else {
                    logMessage("No URL query parameters");
                }
                if ((_b = config === null || config === void 0 ? void 0 : config.options) === null || _b === void 0 ? void 0 : _b.account) {
                    logMessage({
                        Account: config.options.account,
                    });
                }
                return [4 /*yield*/, createTestConfig(logMessage, config)];
            case 1:
                testConfig = _c.sent();
                return [4 /*yield*/, lazyLoadModule(function () { return import("./fingerprint"); })];
            case 2:
                fingerPrintMaker = _c.sent();
                return [4 /*yield*/, fingerPrintMaker.getFingerPrint()];
            case 3:
                fingerPrint = _c.sent();
                logMessage({
                    Fingerprint: "User Agent:" + fingerPrint.userAgent,
                });
                speedTestUrls = testConfig.datacenterRegions
                    .filter(function (item) {
                    return (item.url && (!testConfig.speedAllList || testConfig.speedAllList.indexOf(item.code) >= 0));
                })
                    .map(function (item) {
                    return item.url;
                });
                utcString = new Date().toUTCString();
                timeOffset = "UTC/GMT" + (fingerPrint.timezone.hours >= 0 ? "+" : "-") + fingerPrint.timezone.hours;
                timeZoneMessage = utcString + "; " + fingerPrint.timezone.title + " - " + timeOffset;
                logMessage({
                    // Connection: `${fingerPrint.effectiveConnectionType}`,
                    OS: "" + fingerPrint.platform,
                    Timezone: "" + timeZoneMessage,
                });
                setTestStatus = function (result, threshold, testName) {
                    console.log("tests:test result testname", { result: result, testName: testName });
                    if (testName === "HardwareAvailability") {
                        return;
                    }
                    var valueStatuses = [];
                    var customThresholds = {
                        DNSLookup: function (result) {
                            if ((result === null || result === void 0 ? void 0 : result.totalConnections) !== (result === null || result === void 0 ? void 0 : result.successfulConnections)) {
                                valueStatuses.push(TestStatus.red);
                            }
                        },
                        Location: function (result) {
                            var _a, _b, _c, _d, _e;
                            var underVPN = ((_a = result.traits) === null || _a === void 0 ? void 0 : _a.isAnonymous) ||
                                ((_b = result.traits) === null || _b === void 0 ? void 0 : _b.isAnonymousVpn) ||
                                ((_c = result.traits) === null || _c === void 0 ? void 0 : _c.isHostingProvider) ||
                                ((_d = result.traits) === null || _d === void 0 ? void 0 : _d.isTorExitNode) ||
                                ((_e = result.traits) === null || _e === void 0 ? void 0 : _e.isPublicProxy);
                            if (underVPN) {
                                valueStatuses.push(TestStatus.yellow);
                            }
                        },
                        GetUserMedia: function (result) {
                            var _a;
                            if (((_a = result === null || result === void 0 ? void 0 : result.microphone) === null || _a === void 0 ? void 0 : _a.inputLevel) == 0) {
                                valueStatuses.push(TestStatus.yellow);
                            }
                        },
                    };
                    if (result && result.error) {
                        valueStatuses.push(TestStatus.red);
                    }
                    else if (threshold) {
                        Object.keys(result || {}).forEach(function (key) {
                            var value = +result[key];
                            var thresholdValues = threshold[key];
                            if (value && thresholdValues) {
                                var isLess = thresholdValues.isLess;
                                if (!isLess) {
                                    if (thresholdValues.error && value >= thresholdValues.error) {
                                        valueStatuses.push(TestStatus.red);
                                    }
                                    if (thresholdValues.warning && value >= thresholdValues.warning) {
                                        valueStatuses.push(TestStatus.yellow);
                                    }
                                }
                                else {
                                    if (thresholdValues.error && value <= thresholdValues.error) {
                                        valueStatuses.push(TestStatus.red);
                                    }
                                    if (thresholdValues.warning && value <= thresholdValues.warning) {
                                        valueStatuses.push(TestStatus.yellow);
                                    }
                                }
                            }
                        });
                    }
                    if (customThresholds[testName]) {
                        customThresholds[testName](result);
                    }
                    // if result.meta is not null it means that meta was set in the test
                    // if (!result.meta) {
                    //   result.meta = {
                    //     errorsCount: valueStatuses.filter((x) => x === TestStatus.red).length,
                    //     warningsCount: valueStatuses.filter((x) => x === TestStatus.yellow).length,
                    //   };
                    // }
                    var status = valueStatuses.includes(TestStatus.red)
                        ? TestStatus.red
                        : valueStatuses.includes(TestStatus.yellow)
                            ? TestStatus.yellow
                            : TestStatus.green;
                    testStatuses.push(status);
                };
                testResults = {};
                testStatuses = [];
                actualEstimate = 0;
                testRunInfo = {
                    publicTurn: undefined,
                    optimalRegion: undefined,
                    testConfig: testConfig,
                    testResults: testResults,
                    intermidiatesResults: {},
                    speedTestUrls: speedTestUrls,
                    loggingLevel: window.location.origin.indexOf("localhost") >= 0
                        ? 0
                        : ["debug", "info", "warn"].indexOf(config.loggingLevel || "warn"),
                    logMessage: logMessage,
                    logPingMessage: logPingMessage,
                    logSpeedMessage: logSpeedMessage,
                };
                console.log("tests:runAllTests", { testRunInfo: testRunInfo });
                canceled = cancelControler(function () { return testStatuses.push(TestStatus.red); });
                return [4 /*yield*/, lazyLoadModule(function () { return import("./check-browser"); })];
            case 4:
                checkBrowserTest = _c.sent();
                return [4 /*yield*/, lazyLoadModule(function () { return import("./check-browser-version"); })];
            case 5:
                checkBrowserVersionTest = _c.sent();
                if (!config.browserCheckVersion) return [3 /*break*/, 7];
                return [4 /*yield*/, checkBrowserVersionTest(testConfig, logMessage)];
            case 6:
                _a = _c.sent();
                return [3 /*break*/, 8];
            case 7:
                _a = { canRun: true };
                _c.label = 8;
            case 8:
                checkVersion = _a;
                checkBrowser = checkBrowserTest(testConfig, logMessage);
                if (!(checkBrowser.canRun && checkVersion.canRun)) return [3 /*break*/, 13];
                availableTests = [
                    {
                        id: TestNames.GetUserMedia,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () {
                            var test;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        testRunInfo.logMessage("=== GetUserMedia Test [GetUserMedia] ===");
                                        return [4 /*yield*/, lazyLoadModule(function () { return import("./get-user-media"); })];
                                    case 1:
                                        test = _a.sent();
                                        return [2 /*return*/, test(testRunInfo)];
                                }
                            });
                        }); },
                        resultName: "getUserMedia",
                        // estimatedTime: 0.3,
                        estimatedTime: Estimates.GetUserMedia,
                    },
                    {
                        id: TestNames.Location,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () {
                            var netlifyBaseUrl, netlifyUrl, answer, test;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!testRunInfo.testConfig.isProbe) return [3 /*break*/, 2];
                                        netlifyBaseUrl = (_a = testRunInfo.testConfig.options.netlifyBaseUrl) !== null && _a !== void 0 ? _a : (IsLocalhost() ? "http://localhost:9000" : "");
                                        netlifyUrl = netlifyBaseUrl +
                                            ("/.netlify/functions/get-location?ipInsights=true&config=" + testRunInfo.testConfig.options.config);
                                        return [4 /*yield*/, axios.get(netlifyUrl)];
                                    case 1:
                                        answer = _b.sent();
                                        testRunInfo.testConfig.location = answer.data.location;
                                        _b.label = 2;
                                    case 2:
                                        testRunInfo.logMessage("=== Location Test [Location] ===");
                                        return [4 /*yield*/, lazyLoadModule(function () { return import("./location"); })];
                                    case 3:
                                        test = _b.sent();
                                        return [2 /*return*/, test(testRunInfo)];
                                }
                            });
                        }); },
                        resultName: "location",
                        // estimatedTime: 0.5,
                        estimatedTime: Estimates.Location,
                    },
                    {
                        id: TestNames.GPSLocation,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () {
                            var test;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        testRunInfo.logMessage("=== GPS Location Test [GPSLocation] ===");
                                        return [4 /*yield*/, lazyLoadModule(function () { return import("./gps-location"); })];
                                    case 1:
                                        test = _a.sent();
                                        return [2 /*return*/, test(testRunInfo)];
                                }
                            });
                        }); },
                        resultName: "gpsLocation",
                        estimatedTime: Estimates.GPSLocation,
                    },
                    {
                        id: TestNames.BandwidthSpeed,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, runSpeedTest(testRunInfo)];
                        }); }); },
                        resultName: function (testRunInfo) { var _a; return ((_a = testRunInfo.testConfig.BandwidthSpeed) === null || _a === void 0 ? void 0 : _a.all) ? "speedTest.all" : "speedTest.best"; },
                        // estimatedTime: (testRunInfo: ITestRunInfo) =>
                        //   (testRunInfo.testConfig as any).BandwidthSpeed?.all ? 400 : 40,
                        estimatedTime: function (testRunInfo) {
                            var _a;
                            return ((_a = testRunInfo.testConfig.BandwidthSpeed) === null || _a === void 0 ? void 0 : _a.all)
                                ? Estimates.BandwidthSpeedAll
                                : Estimates.BandwidthSpeed;
                        },
                    },
                    {
                        id: TestNames.VideoP2P,
                        run: runVideoP2PTest,
                        resultName: "videoP2P",
                        // estimatedTime: 45,
                        estimatedTime: Estimates.VideoP2P,
                        timeout: 180000,
                    },
                    {
                        id: TestNames.VideoQuality,
                        run: runVideoQualityTest,
                        resultName: "videoQualityTest",
                        // estimatedTime: 33,
                        estimatedTime: function (testRunInfo) {
                            var _a, _b;
                            var ConnectionInfoName = (_b = (_a = testRunInfo.testConfig) === null || _a === void 0 ? void 0 : _a.VideoQuality) === null || _b === void 0 ? void 0 : _b.ConnectionInfoName;
                            if (ConnectionInfoName === "webex") {
                                return Estimates.WebexVideoQuality;
                            }
                            else if (ConnectionInfoName === null || ConnectionInfoName === void 0 ? void 0 : ConnectionInfoName.includes("twilio")) {
                                return Estimates.TwilioVideoQuality;
                            }
                            else {
                                return Estimates.VideoQuality;
                            }
                        },
                        timeoutMsg: function (testRunInfo) {
                            var _a, _b;
                            var ConnectionInfoName = (_b = (_a = testRunInfo.testConfig) === null || _a === void 0 ? void 0 : _a.VideoQuality) === null || _b === void 0 ? void 0 : _b.ConnectionInfoName;
                            if (ConnectionInfoName === "talview") {
                                return "Error: Timeout, Test was not returned in 120000ms, probably due to bad network conditions";
                            }
                            return null;
                        },
                        timeout: 120000,
                    },
                    {
                        id: TestNames.CallQuality,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () {
                            var connectionName, runNexmoCallQualityTest, _a, _b, _c, _d, _e, _f, _g, _h;
                            return __generator(this, function (_j) {
                                switch (_j.label) {
                                    case 0:
                                        connectionName = GetConnectionInfoName(testRunInfo, TestNames.CallQuality);
                                        console.log("🚀 ~ file: tests.ts:1807 ~ run: ~ connectionName:", connectionName);
                                        if (!(connectionName === "nexmo")) return [3 /*break*/, 4];
                                        testRunInfo.logMessage("=== Call Quality Test [CallQuality:nexmo] ===");
                                        return [4 /*yield*/, lazyLoadModule(function () {
                                                return import("./nexmo/nexmo-call-quality");
                                            })];
                                    case 1:
                                        runNexmoCallQualityTest = _j.sent();
                                        _a = runNexmoCallQualityTest;
                                        _b = [testRunInfo];
                                        return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                                                connectionName: connectionName,
                                            })];
                                    case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([_j.sent()]))];
                                    case 3: return [2 /*return*/, _j.sent()];
                                    case 4:
                                        if (!(connectionName === "jssip")) return [3 /*break*/, 7];
                                        _c = runJsSIPCall;
                                        _d = [testRunInfo];
                                        return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                                                connectionName: connectionName,
                                            })];
                                    case 5: return [4 /*yield*/, _c.apply(void 0, _d.concat([_j.sent()]))];
                                    case 6: return [2 /*return*/, _j.sent()];
                                    case 7:
                                        if (!(connectionName === "livevox_custom")) return [3 /*break*/, 10];
                                        _e = runLivevoxJsSIPCall;
                                        _f = [testRunInfo];
                                        return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                                                connectionName: connectionName,
                                            })];
                                    case 8: return [4 /*yield*/, _e.apply(void 0, _f.concat([_j.sent()]))];
                                    case 9: return [2 /*return*/, _j.sent()];
                                    case 10:
                                        if (!(connectionName === "nice")) return [3 /*break*/, 12];
                                        return [4 /*yield*/, runNiceInContactCallQualityTest(testRunInfo)];
                                    case 11: return [2 /*return*/, _j.sent()];
                                    case 12:
                                        if (!(connectionName === "puzzel")) return [3 /*break*/, 14];
                                        return [4 /*yield*/, runPuzzelCallQualityTest(testRunInfo)];
                                    case 13: return [2 /*return*/, _j.sent()];
                                    case 14:
                                        if (!(connectionName === "twilio-voice")) return [3 /*break*/, 16];
                                        return [4 /*yield*/, runTwilioVoiceCall(testRunInfo)];
                                    case 15: return [2 /*return*/, _j.sent()];
                                    case 16:
                                        if (!(connectionName === "genesys")) return [3 /*break*/, 18];
                                        return [4 /*yield*/, runGenesysVoiceCall(testRunInfo)];
                                    case 17: return [2 /*return*/, _j.sent()];
                                    case 18:
                                        if (!(connectionName === "rcv-op")) return [3 /*break*/, 20];
                                        return [4 /*yield*/, runRingCentralVoiceCall(testRunInfo)];
                                    case 19: return [2 /*return*/, _j.sent()];
                                    case 20:
                                        if (!(connectionName === "dialpad_custom")) return [3 /*break*/, 23];
                                        _g = runDialpadVoiceCall;
                                        _h = [testRunInfo];
                                        return [4 /*yield*/, GetConnectionInfo(testRunInfo, {
                                                connectionName: connectionName,
                                            })];
                                    case 21: return [4 /*yield*/, _g.apply(void 0, _h.concat([_j.sent()]))];
                                    case 22: return [2 /*return*/, _j.sent()];
                                    case 23: return [4 /*yield*/, runTestCall(testRunInfo)];
                                    case 24: return [2 /*return*/, _j.sent()];
                                }
                            });
                        }); },
                        resultName: "testCall",
                        estimatedTime: function (testRunInfo) {
                            var _a, _b;
                            return ((_b = (_a = testRunInfo.testConfig.options) === null || _a === void 0 ? void 0 : _a.dc) === null || _b === void 0 ? void 0 : _b.indexOf(",")) === -1
                                ? Estimates.CallQuality
                                : Estimates.CallQuality2;
                        },
                        // estimatedTime: (testRunInfo: ITestRunInfo) =>
                        //   testRunInfo.testConfig.options?.dc?.indexOf(",") !== -1 ? 52 : 26,
                    },
                    {
                        id: TestNames.VideoBandwidth,
                        run: runVideoBandwidthTest,
                        resultName: "videoBandwidthTest",
                        // estimatedTime: 32,
                        estimatedTime: Estimates.VideoBandwidth,
                    },
                    {
                        id: TestNames.VideoBandwidth2,
                        run: runVideoBandwidthTest2,
                        resultName: "videoBandwidthTest2",
                        // estimatedTime: 32,
                        estimatedTime: Estimates.VideoBandwidth,
                    },
                    {
                        id: TestNames.VideoPlayback,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () {
                            var test;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, lazyLoadModule(function () { return import("./video-playback"); })];
                                    case 1:
                                        test = _a.sent();
                                        return [2 /*return*/, test(testRunInfo)];
                                }
                            });
                        }); },
                        resultName: "videoPlayback",
                        // estimatedTime: 0.05,
                        estimatedTime: Estimates.VideoPlayback,
                    },
                    {
                        id: TestNames.NetworkInformation,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () {
                            var test;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        testRunInfo.logMessage("=== Network Information Test [NetworkInformation] ===");
                                        return [4 /*yield*/, lazyLoadModule(function () { return import("./network-information"); })];
                                    case 1:
                                        test = _a.sent();
                                        return [2 /*return*/, test(testRunInfo)];
                                }
                            });
                        }); },
                        resultName: "networkInformation",
                        estimatedTime: Estimates.NetworkInformation,
                    },
                    {
                        id: TestNames.Throughput,
                        run: runThroughputTest,
                        resultName: "throughput",
                        // estimatedTime: 16.9,
                        estimatedTime: Estimates.Throughput,
                    },
                    {
                        id: TestNames.Traceroute,
                        run: runTracerouteTest,
                        resultName: "Traceroute",
                        // estimatedTime: 16.9,
                        estimatedTime: Estimates.Traceroute,
                        timeout: 55000,
                    },
                    {
                        id: TestNames.TurnConnectivity,
                        run: runConectivityTest,
                        resultName: "turnTest",
                        // estimatedTime: 7,
                        estimatedTime: Estimates.TurnConnectivity,
                    },
                    {
                        id: TestNames.TurnConnectivity2,
                        run: runConectivityTest2,
                        resultName: "turnTest2",
                        estimatedTime: Estimates.TurnConnectivity2,
                    },
                    {
                        id: TestNames.RCVTURNServers,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () {
                            var test;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        testRunInfo.logMessage("=== RCVTURNServers Test [RCVTURNServers] ===");
                                        return [4 /*yield*/, lazyLoadModule(function () { return import("./rcv-turn-servers"); })];
                                    case 1:
                                        test = _a.sent();
                                        return [2 /*return*/, test(testRunInfo)];
                                }
                            });
                        }); },
                        resultName: "rcvTurnServers",
                        // estimatedTime: 25,
                        estimatedTime: Estimates.RCVTURNServers,
                    },
                    {
                        id: TestNames.Ping,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, runPingTest(testRunInfo)];
                        }); }); },
                        resultName: function (testRunInfo) { var _a; return ((_a = testRunInfo.testConfig.Ping) === null || _a === void 0 ? void 0 : _a.all) ? "pingTest.all" : "pingTest.best"; },
                        // estimatedTime: (testRunInfo: ITestRunInfo) =>
                        //   (testRunInfo.testConfig as any).Ping?.all ? 25 : 7.5,
                        estimatedTime: function (testRunInfo) { var _a; return ((_a = testRunInfo.testConfig.Ping) === null || _a === void 0 ? void 0 : _a.all) ? Estimates.PingAll : Estimates.Ping; },
                    },
                    {
                        id: TestNames.DNSLookup,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () {
                            var test;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(testRunInfo.testConfig.theme === "livevox")) return [3 /*break*/, 1];
                                        return [2 /*return*/, runCustomListDNSLookup(testRunInfo)];
                                    case 1:
                                        testRunInfo.logMessage("=== DNS Lookup Test [DNSLookup] ===");
                                        return [4 /*yield*/, lazyLoadModule(function () { return import("./dns-lookup"); })];
                                    case 2:
                                        test = _a.sent();
                                        return [2 /*return*/, test(testRunInfo)];
                                }
                            });
                        }); },
                        resultName: "dnsLookup",
                        // estimatedTime: 10,
                        estimatedTime: function (testRunInfo) {
                            var _a, _b;
                            return ((_a = testRunInfo.testConfig.domains) === null || _a === void 0 ? void 0 : _a.length)
                                ? // 200ms ~ time for one domain
                                    ((_b = testRunInfo.testConfig.domains) === null || _b === void 0 ? void 0 : _b.length) * (200 / 1000)
                                : 0;
                        },
                    },
                    {
                        id: TestNames.DNSSetup,
                        run: runDNSSetupTest,
                        resultName: "dnsSetup",
                        // estimatedTime: 25,
                        estimatedTime: Estimates.DNSSetup,
                        timeout: 180000,
                    },
                    {
                        id: TestNames.DNSSettings,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () {
                            var test;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        testRunInfo.logMessage("=== DNS Settings Test [DNSSettings] ===");
                                        return [4 /*yield*/, lazyLoadModule(function () { return import("./dns-settings"); })];
                                    case 1:
                                        test = _a.sent();
                                        return [2 /*return*/, test(testRunInfo)];
                                }
                            });
                        }); },
                        resultName: "dnsSettings",
                        // estimatedTime: 6.6,
                        estimatedTime: Estimates.DNSSettings,
                    },
                    {
                        id: TestNames.PrivateConnections,
                        run: runPrivateConnectionsTests,
                        resultName: "privateConnections",
                        // estimatedTime: 5.5,
                        estimatedTime: Estimates.PrivateConnections,
                    },
                    {
                        id: TestNames.HardwareAvailability,
                        run: function (testRunInfo) { return __awaiter(void 0, void 0, void 0, function () {
                            var test;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        testRunInfo.logMessage("=== Hardware Availability Test [HardwareAvailability] ===");
                                        return [4 /*yield*/, lazyLoadModule(function () { return import("./hardware-availability"); })];
                                    case 1:
                                        test = _a.sent();
                                        return [2 /*return*/, test(testRunInfo)];
                                }
                            });
                        }); },
                        resultName: "hardwareAvailability",
                        estimatedTime: Estimates.HardwareAvailability,
                        timeout: 5000,
                    },
                    {
                        id: TestNames.DeviceState,
                        run: runDeviceStateTests,
                        resultName: "deviceState",
                        estimatedTime: Estimates.DeviceState,
                    },
                    {
                        id: TestNames.MediaServerIp,
                        run: getMediaServerIp,
                        resultName: "mediaIp",
                        // estimatedTime: 7,
                        estimatedTime: Estimates.TurnConnectivity,
                    },
                ];
                if (testRunInfo.loggingLevel <= 1) {
                    console.info("RUN ALL TESTS", {
                        fingerPrint: fingerPrint,
                        version: version,
                        testsList: testsList,
                        testRunInfo: testRunInfo,
                    });
                }
                if (!(testsList === null || testsList === void 0 ? void 0 : testsList.length)) {
                    throw Error("Invalid test list " + testsList);
                }
                testsData = availableTests.filter(function (test) { return testsList.includes(TestNames[test.id]); });
                getEstimatedTime_1 = function (testData) {
                    return isFunction(testData.estimatedTime)
                        ? testData.estimatedTime(testRunInfo)
                        : testData.estimatedTime;
                };
                totalEstimate = testsData
                    .map(function (t) { return getEstimatedTime_1(t); })
                    .reduce(function (a, b) { return +a + +b; }, 0);
                actualEstimate = 0;
                passedFromStart = 0;
                testRunningIdx = 0;
                finishOneTestFn(null, 0, getEstimatedTime_1(testsData[0]), totalEstimate, canceled.handler);
                _loop_1 = function (testData) {
                    var testName, testId, resultName, resultEstimatedTime, startTime, timeout_1, customTimeoutMsg_1, timeoutTestSetup, timeoutPromise, response, res, keys, testTime, backgroundTestTime, err_8, event_1, error, passedAtEnd;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                resetTestBackgroundTime();
                                testName = TestNames[testData.id];
                                testId = testData.id;
                                resultName = isFunction(testData.resultName)
                                    ? testData.resultName(testRunInfo)
                                    : testData.resultName;
                                resultEstimatedTime = getEstimatedTime_1(testData);
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 3, 4, 5]);
                                canceled.checkCalled();
                                startTime = Date.now();
                                console.group("TEST [" + testName + "]: RUN");
                                timeout_1 = testData.timeout || 120000;
                                customTimeoutMsg_1 = testData.timeoutMsg && isFunction(testData.timeoutMsg)
                                    ? testData.timeoutMsg(testRunInfo)
                                    : null;
                                timeoutTestSetup = GetTestParameter(testRunInfo, testName, "timeout");
                                if (timeoutTestSetup) {
                                    if (typeof timeoutTestSetup !== "number") {
                                        throw new Error("Invalid test timeout value " + testName + " = " + timeoutTestSetup);
                                    }
                                    timeout_1 = timeoutTestSetup;
                                }
                                timeoutPromise = new Promise(function (resolve, reject) {
                                    var id = setTimeout(function () {
                                        clearTimeout(id);
                                        var backgroundTestTime = getTestBackgroundTime();
                                        if (foregroundTestList.includes(testName)) {
                                            if (backgroundTestTime > 5) {
                                                reject({
                                                    error: "User left this browser tab in the background during " + testName + " test for " + Math.round(backgroundTestTime) + " seconds",
                                                });
                                                return;
                                            }
                                            reject({
                                                error: customTimeoutMsg_1
                                                    ? customTimeoutMsg_1
                                                    : "Error: Timeout, Test was not returned in " + timeout_1 + "ms",
                                            });
                                        }
                                    }, timeout_1);
                                });
                                return [4 /*yield*/, Promise.race([
                                        testData.run(testRunInfo),
                                        timeoutPromise,
                                        canceled.promise(),
                                    ])];
                            case 2:
                                response = _d.sent();
                                res = response;
                                keys = Object.keys(res || {});
                                if (keys.length === 1 && keys[0] === testData.resultName) {
                                    testResults = __assign(__assign({}, testResults), res);
                                    console.log("testResults", testResults);
                                }
                                else {
                                    setResults(testResults, resultName, res);
                                }
                                testTime = (Date.now() - startTime) / 1000;
                                actualEstimate += testTime;
                                if (testRunInfo.loggingLevel <= 1) {
                                    console.info("TEST [" + testName + "] SUCCESS (actual:" + testTime + "sec / estimated:" + resultEstimatedTime + ")", res);
                                }
                                // set status on each test and not after all tests run
                                // because here we have test name which is consistent with
                                // threshold name
                                setTestStatus(res, testConfig.colorThresholds ? testConfig.colorThresholds[testName] : null, testName);
                                backgroundTestTime = getTestBackgroundTime();
                                // Check if the current test is included in the foreground test list.
                                if (foregroundTestList.includes(testName)) {
                                    // Check If in any of foregroundTestList tests, the browser tab goes to the background for 5 seconds or more
                                    if (backgroundTestTime > 5) {
                                        // Log a normal message indicating the duration that User left this browser tab during the test for backgroundTestTime seconds.
                                        if (testStatuses[testStatuses.length - 1] == "green") {
                                            testRunInfo.logMessage("User left this browser tab in the background during " + testName + " test for " + Math.round(backgroundTestTime) + " seconds");
                                        }
                                        // If the test failed or didn't meet a threshold (yellow or red status), log the message in red color.
                                        else {
                                            testRunInfo.logMessage("User left this browser tab in the background during " + testName + " test for " + Math.round(backgroundTestTime) + " seconds", "red");
                                        }
                                    }
                                }
                                // Log a dynamic completion message for all of the Tests.
                                testRunInfo.logMessage("=== " + testName + " Test End ===");
                                return [3 /*break*/, 5];
                            case 3:
                                err_8 = _d.sent();
                                undoOveerideRTCPeerConnection();
                                if (testName == "VideoBandwidth") {
                                    event_1 = new Event("videoBandwidthTimeOutErrorHandeler");
                                    document.dispatchEvent(event_1);
                                }
                                error = err_8.message || err_8.error || err_8;
                                setResults(testResults, resultName, { error: error, err: err_8 });
                                testStatuses.push(TestStatus.red);
                                testRunInfo.logMessage("TEST [" + testName + "] " + error, "red");
                                console.error("TEST [" + testName + "]: " + err_8.stack);
                                return [3 /*break*/, 5];
                            case 4:
                                passedFromStart += resultEstimatedTime;
                                testRunningIdx++;
                                passedAtEnd = testRunningIdx >= testsData.length
                                    ? totalEstimate
                                    : passedFromStart + getEstimatedTime_1(testsData[testRunningIdx]);
                                finishOneTestFn(testId, passedFromStart, passedAtEnd, totalEstimate, canceled.handler);
                                console.log(overrideGetstatsFunctions);
                                if (overrideGetstatsFunctions) {
                                    console.warn("TEST [" + testName + "]: ended without calling undoOveerideRTCPeerConnection");
                                }
                                console.groupEnd();
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/];
                        }
                    });
                };
                _i = 0, testsData_1 = testsData;
                _c.label = 9;
            case 9:
                if (!(_i < testsData_1.length)) return [3 /*break*/, 12];
                testData = testsData_1[_i];
                return [5 /*yield**/, _loop_1(testData)];
            case 10:
                _c.sent();
                _c.label = 11;
            case 11:
                _i++;
                return [3 /*break*/, 9];
            case 12:
                if (Math.abs(actualEstimate - totalEstimate) > 0.5 * totalEstimate) {
                    testRunInfo.logMessage("Actual test time different from expected " + Math.round(totalEstimate) + " actual:" + Math.round(actualEstimate), "orange");
                }
                return [3 /*break*/, 14];
            case 13:
                testStatuses.push("red");
                _c.label = 14;
            case 14:
                document.removeEventListener("visibilitychange", logBackgroundTime); // clear listner;
                totalTimeInBackground = getBackgroundTime();
                logMessage("Browser Inactive Time: " + Math.round(totalTimeInBackground) + " s"); // logging total browser inactive time
                result = __assign(__assign({ testPageUrl: window.location.origin, backgroundTime: totalTimeInBackground, fingerprint: fingerPrint, checkBrowser: checkBrowser, checkVersion: checkVersion, status: testStatuses.includes(TestStatus.red)
                        ? TestStatus.red
                        : testStatuses.includes(TestStatus.yellow)
                            ? TestStatus.yellow
                            : TestStatus.green, testTime: Number(actualEstimate.toFixed(2)) }, testResults), { isCanceled: canceled.isCalled(), consoleLog: consoleLog, applyRulesEngine: config === null || config === void 0 ? void 0 : config.applyRulesEngine });
                console.log = oldConsoleLog;
                console.warn = oldConsoleWarn;
                console.error = oldConsoleError;
                console.group = oldConsoleGroup;
                console.info = oldConsoleInfo;
                testRunInfo.logMessage("RUN ALL TESTS completed", "black");
                ////Not releasing WakeLock in case of Probe
                if (!config.isProbe) {
                    releaseWakeLock();
                }
                if (testRunInfo.loggingLevel <= 1) {
                    console.log("runAllTests End", { testRunInfo: testRunInfo, result: result });
                }
                return [2 /*return*/, result];
        }
    });
}); };
//# sourceMappingURL=tests.js.map